var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _g, _g2, _path771, _path772, _g3, _g4, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _g5, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNearmiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3126 133.608C18.6696 122.34 17.1769 106.339 24.6725 95.7477C32.233 85.0594 45.764 84.3833 47.5162 84.319C53.0324 82.3551 59.7817 78.846 62.9292 72.2141C66.7256 64.1657 61.8259 58.6927 64.6165 51.0628C69.646 37.2517 93.171 34.4831 95.2477 34.2577C111.861 32.5192 133.959 38.958 139.085 52.7369C142.849 62.8457 134.802 69.6386 140.286 80.7776C144.018 88.3754 149.372 88.4719 154.661 95.5546C161.832 105.116 166.375 120.762 159.755 129.326C157.711 131.966 155.018 133.382 153.136 134.123",
    fill: "#ECF2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.012 131.965V116.577H152.681V109.237H150.734V83.7392H147.944V80.4554L141.941 77.6867V74.3708H141.13V83.7392H139.961V109.237H138.793V95.844H135.646V88.9223H134.77V109.237H132.369V101.51H130.811V99.5463H127.177V92.7856H125.165V88.0209H122.699V81.0671H121.823V88.0209H119.389V92.7856H117.377V99.5463H113.743V101.51H112.153V109.237H110.304V99.5463H106.637V78.6525H105.469V76.3346H97.6812V78.6525H96.0264V93.7836H89.4069V95.2645H86.9084V96.4235H89.4069V102.347H82.4305V82.6124H80.9379V78.395H77.7255V63.5215H76.8169V78.395H74.4806V82.6124H60.8848V81.228H60.0411V90.5964H58.9054V90.7574H58.1916V100.126H57.0234V102.669H54.5898V95.7796H53.7137V112.231H52.7402V105.309H51.8317V116.094H51.3125V108.367H49.7225V106.371H46.0883V99.6429H44.109V94.8782H41.6429V87.9243H40.7668V94.8782H38.3007V99.6429H36.3214V106.371H32.6547V108.367H31.0972V115.933H30.8051V116.094H30.0264V131.965H154.012Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 83.5142H68.478V84.4478H69.419V83.5142Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 85.0913H68.478V86.0249H69.419V85.0913Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 91.3369H68.478V92.2705H69.419V91.3369Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 92.8823H68.478V93.8159H69.419V92.8823Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 94.46H68.478V95.3936H69.419V94.46Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 99.1279H68.478V100.062H69.419V99.1279Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.419 100.706H68.478V101.639H69.419V100.706Z",
    fill: "#FAFAFA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 89.7593H69.9705V90.6929H70.9115V89.7593Z",
    fill: "#FAFAFA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 91.3369H69.9705V92.2705H70.9115V91.3369Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 92.8823H69.9705V93.8159H70.9115V92.8823Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 94.46H69.9705V95.3936H70.9115V94.46Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 96.0049H69.9705V96.9385H70.9115V96.0049Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 99.1279H69.9705V100.062H70.9115V99.1279Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 100.706H69.9705V101.639H70.9115V100.706Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 83.5142H71.4631V84.4478H72.4041V83.5142Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 85.0913H71.4631V86.0249H72.4041V85.0913Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 86.6367H71.4631V87.5703H72.4041V86.6367Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 88.2144H71.4631V89.148H72.4041V88.2144Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 89.7593H71.4631V90.6929H72.4041V89.7593Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 91.3369H71.4631V92.2705H72.4041V91.3369Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 92.8823H71.4631V93.8159H72.4041V92.8823Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 94.46H71.4631V95.3936H72.4041V94.46Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 96.0049H71.4631V96.9385H72.4041V96.0049Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 97.5825H71.4631V98.5161H72.4041V97.5825Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4041 100.706H71.4631V101.639H72.4041V100.706Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 83.5142H72.9558V84.4478H73.8968V83.5142Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 85.0913H72.9558V86.0249H73.8968V85.0913Z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 86.6367H72.9558V87.5703H73.8968V86.6367Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 88.2144H72.9558V89.148H73.8968V88.2144Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 89.7593H72.9558V90.6929H73.8968V89.7593Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 91.3369H72.9558V92.2705H73.8968V91.3369Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 92.8823H72.9558V93.8159H73.8968V92.8823Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8968 106.951H72.9558V107.885H73.8968V106.951Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 83.5142H74.4485V84.4478H75.3895V83.5142Z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 85.0913H74.4485V86.0249H75.3895V85.0913Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 86.6367H74.4485V87.5703H75.3895V86.6367Z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 88.2144H74.4485V89.148H75.3895V88.2144Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 89.7593H74.4485V90.6929H75.3895V89.7593Z",
    fill: "#FAFAFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 91.3369H74.4485V92.2705H75.3895V91.3369Z",
    fill: "#FAFAFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 92.8823H74.4485V93.8159H75.3895V92.8823Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 94.46H74.4485V95.3936H75.3895V94.46Z",
    fill: "#FAFAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 103.828H74.4485V104.762H75.3895V103.828Z",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 105.406H74.4485V106.339H75.3895V105.406Z",
    fill: "#FAFAFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 106.951H74.4485V107.885H75.3895V106.951Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 108.528H74.4485V109.462H75.3895V108.528Z",
    fill: "#FAFAFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3895 114.774H74.4485V115.708H75.3895V114.774Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 83.5142H75.9412V84.4478H76.8822V83.5142Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 85.0913H75.9412V86.0249H76.8822V85.0913Z",
    fill: "#FAFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 86.6367H75.9412V87.5703H76.8822V86.6367Z",
    fill: "#FAFAFA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 88.2144H75.9412V89.148H76.8822V88.2144Z",
    fill: "#FAFAFA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 89.7593H75.9412V90.6929H76.8822V89.7593Z",
    fill: "#FAFAFA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 91.3369H75.9412V92.2705H76.8822V91.3369Z",
    fill: "#FAFAFA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 92.8823H75.9412V93.8159H76.8822V92.8823Z",
    fill: "#FAFAFA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 94.46H75.9412V95.3936H76.8822V94.46Z",
    fill: "#FAFAFA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 96.0049H75.9412V96.9385H76.8822V96.0049Z",
    fill: "#FAFAFA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 97.5825H75.9412V98.5161H76.8822V97.5825Z",
    fill: "#FAFAFA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 102.283H75.9412V103.216H76.8822V102.283Z",
    fill: "#FAFAFA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 103.828H75.9412V104.762H76.8822V103.828Z",
    fill: "#FAFAFA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 105.406H75.9412V106.339H76.8822V105.406Z",
    fill: "#FAFAFA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 106.951H75.9412V107.885H76.8822V106.951Z",
    fill: "#FAFAFA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 108.528H75.9412V109.462H76.8822V108.528Z",
    fill: "#FAFAFA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8822 114.774H75.9412V115.708H76.8822V114.774Z",
    fill: "#FAFAFA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 83.5142H77.4336V84.4478H78.3746V83.5142Z",
    fill: "#FAFAFA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 85.0913H77.4336V86.0249H78.3746V85.0913Z",
    fill: "#FAFAFA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 86.6367H77.4336V87.5703H78.3746V86.6367Z",
    fill: "#FAFAFA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 88.2144H77.4336V89.148H78.3746V88.2144Z",
    fill: "#FAFAFA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 89.7593H77.4336V90.6929H78.3746V89.7593Z",
    fill: "#FAFAFA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 91.3369H77.4336V92.2705H78.3746V91.3369Z",
    fill: "#FAFAFA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 92.8823H77.4336V93.8159H78.3746V92.8823Z",
    fill: "#FAFAFA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 94.46H77.4336V95.3936H78.3746V94.46Z",
    fill: "#FAFAFA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 96.0049H77.4336V96.9385H78.3746V96.0049Z",
    fill: "#FAFAFA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 97.5825H77.4336V98.5161H78.3746V97.5825Z",
    fill: "#FAFAFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 99.1279H77.4336V100.062H78.3746V99.1279Z",
    fill: "#FAFAFA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 100.706H77.4336V101.639H78.3746V100.706Z",
    fill: "#FAFAFA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 102.283H77.4336V103.216H78.3746V102.283Z",
    fill: "#FAFAFA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 103.828H77.4336V104.762H78.3746V103.828Z",
    fill: "#FAFAFA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 105.406H77.4336V106.339H78.3746V105.406Z",
    fill: "#FAFAFA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 106.951H77.4336V107.885H78.3746V106.951Z",
    fill: "#FAFAFA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 108.528H77.4336V109.462H78.3746V108.528Z",
    fill: "#FAFAFA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3746 110.074H77.4336V111.007H78.3746V110.074Z",
    fill: "#FAFAFA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 83.5142H78.9263V84.4478H79.8673V83.5142Z",
    fill: "#FAFAFA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 85.0913H78.9263V86.0249H79.8673V85.0913Z",
    fill: "#FAFAFA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 86.6367H78.9263V87.5703H79.8673V86.6367Z",
    fill: "#FAFAFA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 88.2144H78.9263V89.148H79.8673V88.2144Z",
    fill: "#FAFAFA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 89.7593H78.9263V90.6929H79.8673V89.7593Z",
    fill: "#FAFAFA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 91.3369H78.9263V92.2705H79.8673V91.3369Z",
    fill: "#FAFAFA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 92.8823H78.9263V93.8159H79.8673V92.8823Z",
    fill: "#FAFAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 94.46H78.9263V95.3936H79.8673V94.46Z",
    fill: "#FAFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 96.0049H78.9263V96.9385H79.8673V96.0049Z",
    fill: "#FAFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 97.5825H78.9263V98.5161H79.8673V97.5825Z",
    fill: "#FAFAFA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 102.283H78.9263V103.216H79.8673V102.283Z",
    fill: "#FAFAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 103.828H78.9263V104.762H79.8673V103.828Z",
    fill: "#FAFAFA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 105.406H78.9263V106.339H79.8673V105.406Z",
    fill: "#FAFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8673 106.951H78.9263V107.885H79.8673V106.951Z",
    fill: "#FAFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 83.5142H80.4189V84.4478H81.36V83.5142Z",
    fill: "#FAFAFA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 85.0913H80.4189V86.0249H81.36V85.0913Z",
    fill: "#FAFAFA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 86.6367H80.4189V87.5703H81.36V86.6367Z",
    fill: "#FAFAFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 88.2144H80.4189V89.148H81.36V88.2144Z",
    fill: "#FAFAFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 89.7593H80.4189V90.6929H81.36V89.7593Z",
    fill: "#FAFAFA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 91.3369H80.4189V92.2705H81.36V91.3369Z",
    fill: "#FAFAFA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 92.8823H80.4189V93.8159H81.36V92.8823Z",
    fill: "#FAFAFA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 94.46H80.4189V95.3936H81.36V94.46Z",
    fill: "#FAFAFA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 96.0049H80.4189V96.9385H81.36V96.0049Z",
    fill: "#FAFAFA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 97.5825H80.4189V98.5161H81.36V97.5825Z",
    fill: "#FAFAFA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 102.283H80.4189V103.216H81.36V102.283Z",
    fill: "#FAFAFA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 103.828H80.4189V104.762H81.36V103.828Z",
    fill: "#FAFAFA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 105.406H80.4189V106.339H81.36V105.406Z",
    fill: "#FAFAFA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 79.4575H97.1948V80.3911H98.1358V79.4575Z",
    fill: "#FAFAFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 81.0352H97.1948V81.9688H98.1358V81.0352Z",
    fill: "#FAFAFA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 82.5801H97.1948V83.5137H98.1358V82.5801Z",
    fill: "#FAFAFA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 84.1577H97.1948V85.0913H98.1358V84.1577Z",
    fill: "#FAFAFA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 85.7031H97.1948V86.6367H98.1358V85.7031Z",
    fill: "#FAFAFA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 87.2808H97.1948V88.2144H98.1358V87.2808Z",
    fill: "#FAFAFA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 88.8257H97.1948V89.7593H98.1358V88.8257Z",
    fill: "#FAFAFA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 90.4033H97.1948V91.3369H98.1358V90.4033Z",
    fill: "#FAFAFA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 95.0713H97.1948V96.0049H98.1358V95.0713Z",
    fill: "#FAFAFA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1358 96.6489H97.1948V97.5825H98.1358V96.6489Z",
    fill: "#FAFAFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 79.4575H98.6873V80.3911H99.6283V79.4575Z",
    fill: "#FAFAFA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 81.0352H98.6873V81.9688H99.6283V81.0352Z",
    fill: "#FAFAFA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 82.5801H98.6873V83.5137H99.6283V82.5801Z",
    fill: "#FAFAFA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 84.1577H98.6873V85.0913H99.6283V84.1577Z",
    fill: "#FAFAFA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 85.7031H98.6873V86.6367H99.6283V85.7031Z",
    fill: "#FAFAFA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 87.2808H98.6873V88.2144H99.6283V87.2808Z",
    fill: "#FAFAFA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 88.8257H98.6873V89.7593H99.6283V88.8257Z",
    fill: "#FAFAFA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 90.4033H98.6873V91.3369H99.6283V90.4033Z",
    fill: "#FAFAFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6283 96.6489H98.6873V97.5825H99.6283V96.6489Z",
    fill: "#FAFAFA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 79.4575H100.18V80.3911H101.121V79.4575Z",
    fill: "#FAFAFA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 81.0352H100.18V81.9688H101.121V81.0352Z",
    fill: "#FAFAFA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 82.5801H100.18V83.5137H101.121V82.5801Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 84.1577H100.18V85.0913H101.121V84.1577Z",
    fill: "#FAFAFA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 85.7031H100.18V86.6367H101.121V85.7031Z",
    fill: "#FAFAFA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 87.2808H100.18V88.2144H101.121V87.2808Z",
    fill: "#FAFAFA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 88.8257H100.18V89.7593H101.121V88.8257Z",
    fill: "#FAFAFA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M101.121 90.4033H100.18V91.3369H101.121V90.4033Z",
    fill: "#FAFAFA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 79.4575H101.673V80.3911H102.614V79.4575Z",
    fill: "#FAFAFA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 81.0352H101.673V81.9688H102.614V81.0352Z",
    fill: "#FAFAFA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 82.5801H101.673V83.5137H102.614V82.5801Z",
    fill: "#FAFAFA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 84.1577H101.673V85.0913H102.614V84.1577Z",
    fill: "#FAFAFA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 85.7031H101.673V86.6367H102.614V85.7031Z",
    fill: "#FAFAFA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 87.2808H101.673V88.2144H102.614V87.2808Z",
    fill: "#FAFAFA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 90.4033H101.673V91.3369H102.614V90.4033Z",
    fill: "#FAFAFA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 91.9487H101.673V92.8823H102.614V91.9487Z",
    fill: "#FAFAFA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 96.6489H101.673V97.5825H102.614V96.6489Z",
    fill: "#FAFAFA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 98.2266H101.673V99.1602H102.614V98.2266Z",
    fill: "#FAFAFA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 99.772H101.673V100.706H102.614V99.772Z",
    fill: "#FAFAFA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 101.349H101.673V102.283H102.614V101.349Z",
    fill: "#FAFAFA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 102.895H101.673V103.828H102.614V102.895Z",
    fill: "#FAFAFA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 104.472H101.673V105.406H102.614V104.472Z",
    fill: "#FAFAFA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M102.614 106.018H101.673V106.951H102.614V106.018Z",
    fill: "#FAFAFA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 79.4575H103.165V80.3911H104.106V79.4575Z",
    fill: "#FAFAFA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 81.0352H103.165V81.9688H104.106V81.0352Z",
    fill: "#FAFAFA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 82.5801H103.165V83.5137H104.106V82.5801Z",
    fill: "#FAFAFA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 84.1577H103.165V85.0913H104.106V84.1577Z",
    fill: "#FAFAFA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 85.7031H103.165V86.6367H104.106V85.7031Z",
    fill: "#FAFAFA"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 87.2808H103.165V88.2144H104.106V87.2808Z",
    fill: "#FAFAFA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 91.9487H103.165V92.8823H104.106V91.9487Z",
    fill: "#FAFAFA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 93.5264H103.165V94.46H104.106V93.5264Z",
    fill: "#FAFAFA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 95.0713H103.165V96.0049H104.106V95.0713Z",
    fill: "#FAFAFA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 96.6489H103.165V97.5825H104.106V96.6489Z",
    fill: "#FAFAFA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 98.2266H103.165V99.1602H104.106V98.2266Z",
    fill: "#FAFAFA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 99.772H103.165V100.706H104.106V99.772Z",
    fill: "#FAFAFA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 101.349H103.165V102.283H104.106V101.349Z",
    fill: "#FAFAFA"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 102.895H103.165V103.828H104.106V102.895Z",
    fill: "#FAFAFA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 104.472H103.165V105.406H104.106V104.472Z",
    fill: "#FAFAFA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 106.018H103.165V106.951H104.106V106.018Z",
    fill: "#FAFAFA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 107.595H103.165V108.528H104.106V107.595Z",
    fill: "#FAFAFA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M104.106 110.718H103.165V111.651H104.106V110.718Z",
    fill: "#FAFAFA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 79.4575H104.658V80.3911H105.599V79.4575Z",
    fill: "#FAFAFA"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 81.0352H104.658V81.9688H105.599V81.0352Z",
    fill: "#FAFAFA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 82.5801H104.658V83.5137H105.599V82.5801Z",
    fill: "#FAFAFA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 84.1577H104.658V85.0913H105.599V84.1577Z",
    fill: "#FAFAFA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 85.7031H104.658V86.6367H105.599V85.7031Z",
    fill: "#FAFAFA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 87.2808H104.658V88.2144H105.599V87.2808Z",
    fill: "#FAFAFA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 91.9487H104.658V92.8823H105.599V91.9487Z",
    fill: "#FAFAFA"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 93.5264H104.658V94.46H105.599V93.5264Z",
    fill: "#FAFAFA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 95.0713H104.658V96.0049H105.599V95.0713Z",
    fill: "#FAFAFA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 96.6489H104.658V97.5825H105.599V96.6489Z",
    fill: "#FAFAFA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 101.349H104.658V102.283H105.599V101.349Z",
    fill: "#FAFAFA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 102.895H104.658V103.828H105.599V102.895Z",
    fill: "#FAFAFA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 104.472H104.658V105.406H105.599V104.472Z",
    fill: "#FAFAFA"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 106.018H104.658V106.951H105.599V106.018Z",
    fill: "#FAFAFA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 107.595H104.658V108.528H105.599V107.595Z",
    fill: "#FAFAFA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 110.718H104.658V111.651H105.599V110.718Z",
    fill: "#FAFAFA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 112.263H104.658V113.196H105.599V112.263Z",
    fill: "#FAFAFA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 93.9771H118.189V94.9107H119.13V93.9771Z",
    fill: "#FAFAFA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 95.5542H118.189V96.4878H119.13V95.5542Z",
    fill: "#FAFAFA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 97.0996H118.189V98.0332H119.13V97.0996Z",
    fill: "#FAFAFA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 98.6772H118.189V99.6109H119.13V98.6772Z",
    fill: "#FAFAFA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 100.255H118.189V101.188H119.13V100.255Z",
    fill: "#FAFAFA"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 101.8H118.189V102.733H119.13V101.8Z",
    fill: "#FAFAFA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 103.377H118.189V104.311H119.13V103.377Z",
    fill: "#FAFAFA"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 108.045H118.189V108.979H119.13V108.045Z",
    fill: "#FAFAFA"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 109.623H118.189V110.557H119.13V109.623Z",
    fill: "#FAFAFA"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13 111.168H118.189V112.102H119.13V111.168Z",
    fill: "#FAFAFA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 93.9771H119.681V94.9107H120.622V93.9771Z",
    fill: "#FAFAFA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 95.5542H119.681V96.4878H120.622V95.5542Z",
    fill: "#FAFAFA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 97.0996H119.681V98.0332H120.622V97.0996Z",
    fill: "#FAFAFA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 98.6772H119.681V99.6109H120.622V98.6772Z",
    fill: "#FAFAFA"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 100.255H119.681V101.188H120.622V100.255Z",
    fill: "#FAFAFA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 101.8H119.681V102.733H120.622V101.8Z",
    fill: "#FAFAFA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 103.377H119.681V104.311H120.622V103.377Z",
    fill: "#FAFAFA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 93.9771H121.174V94.9107H122.115V93.9771Z",
    fill: "#FAFAFA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 95.5542H121.174V96.4878H122.115V95.5542Z",
    fill: "#FAFAFA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 97.0996H121.174V98.0332H122.115V97.0996Z",
    fill: "#FAFAFA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 98.6772H121.174V99.6109H122.115V98.6772Z",
    fill: "#FAFAFA"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 100.255H121.174V101.188H122.115V100.255Z",
    fill: "#FAFAFA"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 101.8H121.174V102.733H122.115V101.8Z",
    fill: "#FAFAFA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M122.115 103.377H121.174V104.311H122.115V103.377Z",
    fill: "#FAFAFA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 93.9771H122.667V94.9107H123.608V93.9771Z",
    fill: "#FAFAFA"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 95.5542H122.667V96.4878H123.608V95.5542Z",
    fill: "#FAFAFA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 97.0996H122.667V98.0332H123.608V97.0996Z",
    fill: "#FAFAFA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 98.6772H122.667V99.6109H123.608V98.6772Z",
    fill: "#FAFAFA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 100.255H122.667V101.188H123.608V100.255Z",
    fill: "#FAFAFA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 101.8H122.667V102.733H123.608V101.8Z",
    fill: "#FAFAFA"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 103.377H122.667V104.311H123.608V103.377Z",
    fill: "#FAFAFA"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 104.923H122.667V105.856H123.608V104.923Z",
    fill: "#FAFAFA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 106.5H122.667V107.434H123.608V106.5Z",
    fill: "#FAFAFA"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 108.045H122.667V108.979H123.608V108.045Z",
    fill: "#FAFAFA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M123.608 109.623H122.667V110.557H123.608V109.623Z",
    fill: "#FAFAFA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 93.9771H124.159V94.9107H125.1V93.9771Z",
    fill: "#FAFAFA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 95.5542H124.159V96.4878H125.1V95.5542Z",
    fill: "#FAFAFA"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 97.0996H124.159V98.0332H125.1V97.0996Z",
    fill: "#FAFAFA"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 98.6772H124.159V99.6109H125.1V98.6772Z",
    fill: "#FAFAFA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 100.255H124.159V101.188H125.1V100.255Z",
    fill: "#FAFAFA"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 101.8H124.159V102.733H125.1V101.8Z",
    fill: "#FAFAFA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 103.377H124.159V104.311H125.1V103.377Z",
    fill: "#FAFAFA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 104.923H124.159V105.856H125.1V104.923Z",
    fill: "#FAFAFA"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 106.5H124.159V107.434H125.1V106.5Z",
    fill: "#FAFAFA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 108.045H124.159V108.979H125.1V108.045Z",
    fill: "#FAFAFA"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 109.623H124.159V110.557H125.1V109.623Z",
    fill: "#FAFAFA"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 111.168H124.159V112.102H125.1V111.168Z",
    fill: "#FAFAFA"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 115.869H124.159V116.802H125.1V115.869Z",
    fill: "#FAFAFA"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 117.414H124.159V118.348H125.1V117.414Z",
    fill: "#FAFAFA"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 93.9771H125.652V94.9107H126.593V93.9771Z",
    fill: "#FAFAFA"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 95.5542H125.652V96.4878H126.593V95.5542Z",
    fill: "#FAFAFA"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 97.0996H125.652V98.0332H126.593V97.0996Z",
    fill: "#FAFAFA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 101.8H125.652V102.733H126.593V101.8Z",
    fill: "#FAFAFA"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 103.377H125.652V104.311H126.593V103.377Z",
    fill: "#FAFAFA"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 104.923H125.652V105.856H126.593V104.923Z",
    fill: "#FAFAFA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 106.5H125.652V107.434H126.593V106.5Z",
    fill: "#FAFAFA"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 108.045H125.652V108.979H126.593V108.045Z",
    fill: "#FAFAFA"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 109.623H125.652V110.557H126.593V109.623Z",
    fill: "#FAFAFA"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 111.168H125.652V112.102H126.593V111.168Z",
    fill: "#FAFAFA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 115.869H125.652V116.802H126.593V115.869Z",
    fill: "#FAFAFA"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 117.414H125.652V118.348H126.593V117.414Z",
    fill: "#FAFAFA"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M126.593 118.991H125.652V119.925H126.593V118.991Z",
    fill: "#FAFAFA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 84.6084H141.292V85.542H142.233V84.6084Z",
    fill: "#FAFAFA"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 86.186H141.292V87.1197H142.233V86.186Z",
    fill: "#FAFAFA"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 87.7314H141.292V88.6651H142.233V87.7314Z",
    fill: "#FAFAFA"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 89.3086H141.292V90.2422H142.233V89.3086Z",
    fill: "#FAFAFA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 90.854H141.292V91.7876H142.233V90.854Z",
    fill: "#FAFAFA"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 92.4316H141.292V93.3653H142.233V92.4316Z",
    fill: "#FAFAFA"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 93.9771H141.292V94.9107H142.233V93.9771Z",
    fill: "#FAFAFA"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 95.5542H141.292V96.4878H142.233V95.5542Z",
    fill: "#FAFAFA"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 97.0996H141.292V98.0332H142.233V97.0996Z",
    fill: "#FAFAFA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 98.6772H141.292V99.6109H142.233V98.6772Z",
    fill: "#FAFAFA"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 100.255H141.292V101.188H142.233V100.255Z",
    fill: "#FAFAFA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 101.8H141.292V102.733H142.233V101.8Z",
    fill: "#FAFAFA"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 103.377H141.292V104.311H142.233V103.377Z",
    fill: "#FAFAFA"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 104.923H141.292V105.856H142.233V104.923Z",
    fill: "#FAFAFA"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 106.5H141.292V107.434H142.233V106.5Z",
    fill: "#FAFAFA"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 108.045H141.292V108.979H142.233V108.045Z",
    fill: "#FAFAFA"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 109.623H141.292V110.557H142.233V109.623Z",
    fill: "#FAFAFA"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 111.168H141.292V112.102H142.233V111.168Z",
    fill: "#FAFAFA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 112.746H141.292V113.679H142.233V112.746Z",
    fill: "#FAFAFA"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 114.291H141.292V115.225H142.233V114.291Z",
    fill: "#FAFAFA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 115.869H141.292V116.802H142.233V115.869Z",
    fill: "#FAFAFA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 117.414H141.292V118.348H142.233V117.414Z",
    fill: "#FAFAFA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 118.991H141.292V119.925H142.233V118.991Z",
    fill: "#FAFAFA"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 84.6084H142.785V85.542H143.726V84.6084Z",
    fill: "#FAFAFA"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 86.186H142.785V87.1197H143.726V86.186Z",
    fill: "#FAFAFA"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 87.7314H142.785V88.6651H143.726V87.7314Z",
    fill: "#FAFAFA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 89.3086H142.785V90.2422H143.726V89.3086Z",
    fill: "#FAFAFA"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 90.854H142.785V91.7876H143.726V90.854Z",
    fill: "#FAFAFA"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 92.4316H142.785V93.3653H143.726V92.4316Z",
    fill: "#FAFAFA"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 93.9771H142.785V94.9107H143.726V93.9771Z",
    fill: "#FAFAFA"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 95.5542H142.785V96.4878H143.726V95.5542Z",
    fill: "#FAFAFA"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 97.0996H142.785V98.0332H143.726V97.0996Z",
    fill: "#FAFAFA"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 98.6772H142.785V99.6109H143.726V98.6772Z",
    fill: "#FAFAFA"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 100.255H142.785V101.188H143.726V100.255Z",
    fill: "#FAFAFA"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 101.8H142.785V102.733H143.726V101.8Z",
    fill: "#FAFAFA"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 103.377H142.785V104.311H143.726V103.377Z",
    fill: "#FAFAFA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 104.923H142.785V105.856H143.726V104.923Z",
    fill: "#FAFAFA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 106.5H142.785V107.434H143.726V106.5Z",
    fill: "#FAFAFA"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 108.045H142.785V108.979H143.726V108.045Z",
    fill: "#FAFAFA"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 109.623H142.785V110.557H143.726V109.623Z",
    fill: "#FAFAFA"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 111.168H142.785V112.102H143.726V111.168Z",
    fill: "#FAFAFA"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 112.746H142.785V113.679H143.726V112.746Z",
    fill: "#FAFAFA"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 84.6084H144.277V85.542H145.218V84.6084Z",
    fill: "#FAFAFA"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 86.186H144.277V87.1197H145.218V86.186Z",
    fill: "#FAFAFA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 87.7314H144.277V88.6651H145.218V87.7314Z",
    fill: "#FAFAFA"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 89.3086H144.277V90.2422H145.218V89.3086Z",
    fill: "#FAFAFA"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 90.854H144.277V91.7876H145.218V90.854Z",
    fill: "#FAFAFA"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 92.4316H144.277V93.3653H145.218V92.4316Z",
    fill: "#FAFAFA"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 93.9771H144.277V94.9107H145.218V93.9771Z",
    fill: "#FAFAFA"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 95.5542H144.277V96.4878H145.218V95.5542Z",
    fill: "#FAFAFA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 97.0996H144.277V98.0332H145.218V97.0996Z",
    fill: "#FAFAFA"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 98.6772H144.277V99.6109H145.218V98.6772Z",
    fill: "#FAFAFA"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 100.255H144.277V101.188H145.218V100.255Z",
    fill: "#FAFAFA"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 101.8H144.277V102.733H145.218V101.8Z",
    fill: "#FAFAFA"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 103.377H144.277V104.311H145.218V103.377Z",
    fill: "#FAFAFA"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 104.923H144.277V105.856H145.218V104.923Z",
    fill: "#FAFAFA"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 106.5H144.277V107.434H145.218V106.5Z",
    fill: "#FAFAFA"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 108.045H144.277V108.979H145.218V108.045Z",
    fill: "#FAFAFA"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 109.623H144.277V110.557H145.218V109.623Z",
    fill: "#FAFAFA"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 111.168H144.277V112.102H145.218V111.168Z",
    fill: "#FAFAFA"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 112.746H144.277V113.679H145.218V112.746Z",
    fill: "#FAFAFA"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 84.6084H145.77V85.542H146.711V84.6084Z",
    fill: "#FAFAFA"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 86.186H145.77V87.1197H146.711V86.186Z",
    fill: "#FAFAFA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 87.7314H145.77V88.6651H146.711V87.7314Z",
    fill: "#FAFAFA"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 89.3086H145.77V90.2422H146.711V89.3086Z",
    fill: "#FAFAFA"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 90.854H145.77V91.7876H146.711V90.854Z",
    fill: "#FAFAFA"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 92.4316H145.77V93.3653H146.711V92.4316Z",
    fill: "#FAFAFA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 93.9771H145.77V94.9107H146.711V93.9771Z",
    fill: "#FAFAFA"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 95.5542H145.77V96.4878H146.711V95.5542Z",
    fill: "#FAFAFA"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 97.0996H145.77V98.0332H146.711V97.0996Z",
    fill: "#FAFAFA"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 98.6772H145.77V99.6109H146.711V98.6772Z",
    fill: "#FAFAFA"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 100.255H145.77V101.188H146.711V100.255Z",
    fill: "#FAFAFA"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 101.8H145.77V102.733H146.711V101.8Z",
    fill: "#FAFAFA"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 103.377H145.77V104.311H146.711V103.377Z",
    fill: "#FAFAFA"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 104.923H145.77V105.856H146.711V104.923Z",
    fill: "#FAFAFA"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 106.5H145.77V107.434H146.711V106.5Z",
    fill: "#FAFAFA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 84.6084H147.263V85.542H148.204V84.6084Z",
    fill: "#FAFAFA"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 86.186H147.263V87.1197H148.204V86.186Z",
    fill: "#FAFAFA"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 87.7314H147.263V88.6651H148.204V87.7314Z",
    fill: "#FAFAFA"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 89.3086H147.263V90.2422H148.204V89.3086Z",
    fill: "#FAFAFA"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 90.854H147.263V91.7876H148.204V90.854Z",
    fill: "#FAFAFA"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 92.4316H147.263V93.3653H148.204V92.4316Z",
    fill: "#FAFAFA"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 93.9771H147.263V94.9107H148.204V93.9771Z",
    fill: "#FAFAFA"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 95.5542H147.263V96.4878H148.204V95.5542Z",
    fill: "#FAFAFA"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 97.0996H147.263V98.0332H148.204V97.0996Z",
    fill: "#FAFAFA"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 98.6772H147.263V99.6109H148.204V98.6772Z",
    fill: "#FAFAFA"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 100.255H147.263V101.188H148.204V100.255Z",
    fill: "#FAFAFA"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 101.8H147.263V102.733H148.204V101.8Z",
    fill: "#FAFAFA"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 103.377H147.263V104.311H148.204V103.377Z",
    fill: "#FAFAFA"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 84.6084H148.755V85.542H149.696V84.6084Z",
    fill: "#FAFAFA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 86.186H148.755V87.1197H149.696V86.186Z",
    fill: "#FAFAFA"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 87.7314H148.755V88.6651H149.696V87.7314Z",
    fill: "#FAFAFA"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 89.3086H148.755V90.2422H149.696V89.3086Z",
    fill: "#FAFAFA"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 90.854H148.755V91.7876H149.696V90.854Z",
    fill: "#FAFAFA"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 92.4316H148.755V93.3653H149.696V92.4316Z",
    fill: "#FAFAFA"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 93.9771H148.755V94.9107H149.696V93.9771Z",
    fill: "#FAFAFA"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 95.5542H148.755V96.4878H149.696V95.5542Z",
    fill: "#FAFAFA"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 97.0996H148.755V98.0332H149.696V97.0996Z",
    fill: "#FAFAFA"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 98.6772H148.755V99.6109H149.696V98.6772Z",
    fill: "#FAFAFA"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 100.255H148.755V101.188H149.696V100.255Z",
    fill: "#FAFAFA"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 101.8H148.755V102.733H149.696V101.8Z",
    fill: "#FAFAFA"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 96.0049H39.1445V96.9385H40.0855V96.0049Z",
    fill: "#FAFAFA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 97.5825H39.1445V98.5161H40.0855V97.5825Z",
    fill: "#FAFAFA"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 99.1279H39.1445V100.062H40.0855V99.1279Z",
    fill: "#FAFAFA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 100.706H39.1445V101.639H40.0855V100.706Z",
    fill: "#FAFAFA"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 102.283H39.1445V103.216H40.0855V102.283Z",
    fill: "#FAFAFA"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 103.828H39.1445V104.762H40.0855V103.828Z",
    fill: "#FAFAFA"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 105.406H39.1445V106.339H40.0855V105.406Z",
    fill: "#FAFAFA"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 106.951H39.1445V107.885H40.0855V106.951Z",
    fill: "#FAFAFA"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 108.528H39.1445V109.462H40.0855V108.528Z",
    fill: "#FAFAFA"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 110.074H39.1445V111.007H40.0855V110.074Z",
    fill: "#FAFAFA"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 111.651H39.1445V112.585H40.0855V111.651Z",
    fill: "#FAFAFA"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 113.197H39.1445V114.13H40.0855V113.197Z",
    fill: "#FAFAFA"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 114.774H39.1445V115.708H40.0855V114.774Z",
    fill: "#FAFAFA"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 116.319H39.1445V117.253H40.0855V116.319Z",
    fill: "#FAFAFA"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 117.897H39.1445V118.831H40.0855V117.897Z",
    fill: "#FAFAFA"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 119.442H39.1445V120.376H40.0855V119.442Z",
    fill: "#FAFAFA"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 121.02H39.1445V121.953H40.0855V121.02Z",
    fill: "#FAFAFA"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 122.565H39.1445V123.499H40.0855V122.565Z",
    fill: "#FAFAFA"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 124.143H39.1445V125.076H40.0855V124.143Z",
    fill: "#FAFAFA"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0855 125.72H39.1445V126.653H40.0855V125.72Z",
    fill: "#FAFAFA"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 96.0049H40.6372V96.9385H41.5782V96.0049Z",
    fill: "#FAFAFA"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 97.5825H40.6372V98.5161H41.5782V97.5825Z",
    fill: "#FAFAFA"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 99.1279H40.6372V100.062H41.5782V99.1279Z",
    fill: "#FAFAFA"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 100.706H40.6372V101.639H41.5782V100.706Z",
    fill: "#FAFAFA"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 102.283H40.6372V103.216H41.5782V102.283Z",
    fill: "#FAFAFA"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 103.828H40.6372V104.762H41.5782V103.828Z",
    fill: "#FAFAFA"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 105.406H40.6372V106.339H41.5782V105.406Z",
    fill: "#FAFAFA"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 106.951H40.6372V107.885H41.5782V106.951Z",
    fill: "#FAFAFA"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 108.528H40.6372V109.462H41.5782V108.528Z",
    fill: "#FAFAFA"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 110.074H40.6372V111.007H41.5782V110.074Z",
    fill: "#FAFAFA"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 111.651H40.6372V112.585H41.5782V111.651Z",
    fill: "#FAFAFA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 113.197H40.6372V114.13H41.5782V113.197Z",
    fill: "#FAFAFA"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 114.774H40.6372V115.708H41.5782V114.774Z",
    fill: "#FAFAFA"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 116.319H40.6372V117.253H41.5782V116.319Z",
    fill: "#FAFAFA"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 117.897H40.6372V118.831H41.5782V117.897Z",
    fill: "#FAFAFA"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 119.442H40.6372V120.376H41.5782V119.442Z",
    fill: "#FAFAFA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 121.02H40.6372V121.953H41.5782V121.02Z",
    fill: "#FAFAFA"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5782 122.565H40.6372V123.499H41.5782V122.565Z",
    fill: "#FAFAFA"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 96.0049H42.1299V96.9385H43.0709V96.0049Z",
    fill: "#FAFAFA"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 97.5825H42.1299V98.5161H43.0709V97.5825Z",
    fill: "#FAFAFA"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 99.1279H42.1299V100.062H43.0709V99.1279Z",
    fill: "#FAFAFA"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 100.706H42.1299V101.639H43.0709V100.706Z",
    fill: "#FAFAFA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 102.283H42.1299V103.216H43.0709V102.283Z",
    fill: "#FAFAFA"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 103.828H42.1299V104.762H43.0709V103.828Z",
    fill: "#FAFAFA"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 105.406H42.1299V106.339H43.0709V105.406Z",
    fill: "#FAFAFA"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 106.951H42.1299V107.885H43.0709V106.951Z",
    fill: "#FAFAFA"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 108.528H42.1299V109.462H43.0709V108.528Z",
    fill: "#FAFAFA"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 110.074H42.1299V111.007H43.0709V110.074Z",
    fill: "#FAFAFA"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 111.651H42.1299V112.585H43.0709V111.651Z",
    fill: "#FAFAFA"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 113.197H42.1299V114.13H43.0709V113.197Z",
    fill: "#FAFAFA"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 114.774H42.1299V115.708H43.0709V114.774Z",
    fill: "#FAFAFA"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 116.319H42.1299V117.253H43.0709V116.319Z",
    fill: "#FAFAFA"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 117.897H42.1299V118.831H43.0709V117.897Z",
    fill: "#FAFAFA"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 119.442H42.1299V120.376H43.0709V119.442Z",
    fill: "#FAFAFA"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 121.02H42.1299V121.953H43.0709V121.02Z",
    fill: "#FAFAFA"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0709 122.565H42.1299V123.499H43.0709V122.565Z",
    fill: "#FAFAFA"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 107.434H33.5635V108.368H34.5045V107.434Z",
    fill: "#FAFAFA"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 108.979H33.5635V109.913H34.5045V108.979Z",
    fill: "#FAFAFA"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 110.557H33.5635V111.49H34.5045V110.557Z",
    fill: "#FAFAFA"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 112.102H33.5635V113.036H34.5045V112.102Z",
    fill: "#FAFAFA"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 113.68H33.5635V114.613H34.5045V113.68Z",
    fill: "#FAFAFA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 115.225H33.5635V116.158H34.5045V115.225Z",
    fill: "#FAFAFA"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 116.802H33.5635V117.736H34.5045V116.802Z",
    fill: "#FAFAFA"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 118.348H33.5635V119.281H34.5045V118.348Z",
    fill: "#FAFAFA"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 119.925H33.5635V120.858H34.5045V119.925Z",
    fill: "#FAFAFA"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 121.47H33.5635V122.404H34.5045V121.47Z",
    fill: "#FAFAFA"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 123.048H33.5635V123.981H34.5045V123.048Z",
    fill: "#FAFAFA"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 124.593H33.5635V125.527H34.5045V124.593Z",
    fill: "#FAFAFA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5045 126.17H33.5635V127.104H34.5045V126.17Z",
    fill: "#FAFAFA"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 107.434H35.0562V108.368H35.9972V107.434Z",
    fill: "#FAFAFA"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 108.979H35.0562V109.913H35.9972V108.979Z",
    fill: "#FAFAFA"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 110.557H35.0562V111.49H35.9972V110.557Z",
    fill: "#FAFAFA"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 112.102H35.0562V113.036H35.9972V112.102Z",
    fill: "#FAFAFA"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 113.68H35.0562V114.613H35.9972V113.68Z",
    fill: "#FAFAFA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 115.225H35.0562V116.158H35.9972V115.225Z",
    fill: "#FAFAFA"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 116.802H35.0562V117.736H35.9972V116.802Z",
    fill: "#FAFAFA"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 118.348H35.0562V119.281H35.9972V118.348Z",
    fill: "#FAFAFA"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 119.925H35.0562V120.858H35.9972V119.925Z",
    fill: "#FAFAFA"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 121.47H35.0562V122.404H35.9972V121.47Z",
    fill: "#FAFAFA"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 123.048H35.0562V123.981H35.9972V123.048Z",
    fill: "#FAFAFA"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 124.593H35.0562V125.527H35.9972V124.593Z",
    fill: "#FAFAFA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9972 126.17H35.0562V127.104H35.9972V126.17Z",
    fill: "#FAFAFA"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 107.434H36.5488V108.368H37.4898V107.434Z",
    fill: "#FAFAFA"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 108.979H36.5488V109.913H37.4898V108.979Z",
    fill: "#FAFAFA"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 110.557H36.5488V111.49H37.4898V110.557Z",
    fill: "#FAFAFA"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 112.102H36.5488V113.036H37.4898V112.102Z",
    fill: "#FAFAFA"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 113.68H36.5488V114.613H37.4898V113.68Z",
    fill: "#FAFAFA"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 115.225H36.5488V116.158H37.4898V115.225Z",
    fill: "#FAFAFA"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 116.802H36.5488V117.736H37.4898V116.802Z",
    fill: "#FAFAFA"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 118.348H36.5488V119.281H37.4898V118.348Z",
    fill: "#FAFAFA"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 119.925H36.5488V120.858H37.4898V119.925Z",
    fill: "#FAFAFA"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 121.47H36.5488V122.404H37.4898V121.47Z",
    fill: "#FAFAFA"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 123.048H36.5488V123.981H37.4898V123.048Z",
    fill: "#FAFAFA"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 124.593H36.5488V125.527H37.4898V124.593Z",
    fill: "#FAFAFA"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 126.17H36.5488V127.104H37.4898V126.17Z",
    fill: "#FAFAFA"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 127.748H36.5488V128.682H37.4898V127.748Z",
    fill: "#FAFAFA"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 107.885H44.8232V108.818H45.7642V107.885Z",
    fill: "#FAFAFA"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 109.462H44.8232V110.396H45.7642V109.462Z",
    fill: "#FAFAFA"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 111.007H44.8232V111.941H45.7642V111.007Z",
    fill: "#FAFAFA"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 112.585H44.8232V113.519H45.7642V112.585Z",
    fill: "#FAFAFA"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 114.13H44.8232V115.064H45.7642V114.13Z",
    fill: "#FAFAFA"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 115.708H44.8232V116.641H45.7642V115.708Z",
    fill: "#FAFAFA"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 117.253H44.8232V118.187H45.7642V117.253Z",
    fill: "#FAFAFA"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 118.831H44.8232V119.764H45.7642V118.831Z",
    fill: "#FAFAFA"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 120.376H44.8232V121.31H45.7642V120.376Z",
    fill: "#FAFAFA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 121.953H44.8232V122.887H45.7642V121.953Z",
    fill: "#FAFAFA"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7642 126.622H44.8232V127.555H45.7642V126.622Z",
    fill: "#FAFAFA"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 107.885H46.3157V108.818H47.2567V107.885Z",
    fill: "#FAFAFA"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 109.462H46.3157V110.396H47.2567V109.462Z",
    fill: "#FAFAFA"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 111.007H46.3157V111.941H47.2567V111.007Z",
    fill: "#FAFAFA"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 112.585H46.3157V113.519H47.2567V112.585Z",
    fill: "#FAFAFA"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 114.13H46.3157V115.064H47.2567V114.13Z",
    fill: "#FAFAFA"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 115.708H46.3157V116.641H47.2567V115.708Z",
    fill: "#FAFAFA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 117.253H46.3157V118.187H47.2567V117.253Z",
    fill: "#FAFAFA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 118.831H46.3157V119.764H47.2567V118.831Z",
    fill: "#FAFAFA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 120.376H46.3157V121.31H47.2567V120.376Z",
    fill: "#FAFAFA"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 125.076H46.3157V126.01H47.2567V125.076Z",
    fill: "#FAFAFA"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2567 126.622H46.3157V127.555H47.2567V126.622Z",
    fill: "#FAFAFA"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 107.885H47.8083V108.818H48.7494V107.885Z",
    fill: "#FAFAFA"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 109.462H47.8083V110.396H48.7494V109.462Z",
    fill: "#FAFAFA"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 111.007H47.8083V111.941H48.7494V111.007Z",
    fill: "#FAFAFA"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 112.585H47.8083V113.519H48.7494V112.585Z",
    fill: "#FAFAFA"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 114.13H47.8083V115.064H48.7494V114.13Z",
    fill: "#FAFAFA"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 115.708H47.8083V116.641H48.7494V115.708Z",
    fill: "#FAFAFA"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 117.253H47.8083V118.187H48.7494V117.253Z",
    fill: "#FAFAFA"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 118.831H47.8083V119.764H48.7494V118.831Z",
    fill: "#FAFAFA"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 123.499H47.8083V124.432H48.7494V123.499Z",
    fill: "#FAFAFA"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 125.076H47.8083V126.01H48.7494V125.076Z",
    fill: "#FAFAFA"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7494 126.622H47.8083V127.555H48.7494V126.622Z",
    fill: "#FAFAFA"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 84.1577H61.6638V85.0913H62.6048V84.1577Z",
    fill: "#FAFAFA"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 85.7031H61.6638V86.6367H62.6048V85.7031Z",
    fill: "#FAFAFA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 87.2808H61.6638V88.2144H62.6048V87.2808Z",
    fill: "#FAFAFA"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 88.8257H61.6638V89.7593H62.6048V88.8257Z",
    fill: "#FAFAFA"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 90.4033H61.6638V91.3369H62.6048V90.4033Z",
    fill: "#FAFAFA"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 91.9487H61.6638V92.8823H62.6048V91.9487Z",
    fill: "#FAFAFA"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 93.5264H61.6638V94.46H62.6048V93.5264Z",
    fill: "#FAFAFA"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 95.0713H61.6638V96.0049H62.6048V95.0713Z",
    fill: "#FAFAFA"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 96.6489H61.6638V97.5825H62.6048V96.6489Z",
    fill: "#FAFAFA"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 98.2266H61.6638V99.1602H62.6048V98.2266Z",
    fill: "#FAFAFA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 99.772H61.6638V100.706H62.6048V99.772Z",
    fill: "#FAFAFA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 101.349H61.6638V102.283H62.6048V101.349Z",
    fill: "#FAFAFA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 102.895H61.6638V103.828H62.6048V102.895Z",
    fill: "#FAFAFA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 104.472H61.6638V105.406H62.6048V104.472Z",
    fill: "#FAFAFA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 106.018H61.6638V106.951H62.6048V106.018Z",
    fill: "#FAFAFA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 107.595H61.6638V108.528H62.6048V107.595Z",
    fill: "#FAFAFA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 109.14H61.6638V110.074H62.6048V109.14Z",
    fill: "#FAFAFA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 112.263H61.6638V113.196H62.6048V112.263Z",
    fill: "#FAFAFA"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 113.84H61.6638V114.774H62.6048V113.84Z",
    fill: "#FAFAFA"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 115.386H61.6638V116.319H62.6048V115.386Z",
    fill: "#FAFAFA"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 116.963H61.6638V117.897H62.6048V116.963Z",
    fill: "#FAFAFA"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6048 118.508H61.6638V119.442H62.6048V118.508Z",
    fill: "#FAFAFA"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 84.1577H63.1565V85.0913H64.0975V84.1577Z",
    fill: "#FAFAFA"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 85.7031H63.1565V86.6367H64.0975V85.7031Z",
    fill: "#FAFAFA"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 87.2808H63.1565V88.2144H64.0975V87.2808Z",
    fill: "#FAFAFA"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 88.8257H63.1565V89.7593H64.0975V88.8257Z",
    fill: "#FAFAFA"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 90.4033H63.1565V91.3369H64.0975V90.4033Z",
    fill: "#FAFAFA"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 91.9487H63.1565V92.8823H64.0975V91.9487Z",
    fill: "#FAFAFA"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 93.5264H63.1565V94.46H64.0975V93.5264Z",
    fill: "#FAFAFA"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 95.0713H63.1565V96.0049H64.0975V95.0713Z",
    fill: "#FAFAFA"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 96.6489H63.1565V97.5825H64.0975V96.6489Z",
    fill: "#FAFAFA"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 98.2266H63.1565V99.1602H64.0975V98.2266Z",
    fill: "#FAFAFA"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 99.772H63.1565V100.706H64.0975V99.772Z",
    fill: "#FAFAFA"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 101.349H63.1565V102.283H64.0975V101.349Z",
    fill: "#FAFAFA"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 102.895H63.1565V103.828H64.0975V102.895Z",
    fill: "#FAFAFA"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 104.472H63.1565V105.406H64.0975V104.472Z",
    fill: "#FAFAFA"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 106.018H63.1565V106.951H64.0975V106.018Z",
    fill: "#FAFAFA"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 107.595H63.1565V108.528H64.0975V107.595Z",
    fill: "#FAFAFA"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 116.963H63.1565V117.897H64.0975V116.963Z",
    fill: "#FAFAFA"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 118.508H63.1565V119.442H64.0975V118.508Z",
    fill: "#FAFAFA"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 84.1577H64.6489V85.0913H65.5899V84.1577Z",
    fill: "#FAFAFA"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 85.7031H64.6489V86.6367H65.5899V85.7031Z",
    fill: "#FAFAFA"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 87.2808H64.6489V88.2144H65.5899V87.2808Z",
    fill: "#FAFAFA"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 88.8257H64.6489V89.7593H65.5899V88.8257Z",
    fill: "#FAFAFA"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 90.4033H64.6489V91.3369H65.5899V90.4033Z",
    fill: "#FAFAFA"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 91.9487H64.6489V92.8823H65.5899V91.9487Z",
    fill: "#FAFAFA"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 93.5264H64.6489V94.46H65.5899V93.5264Z",
    fill: "#FAFAFA"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 95.0713H64.6489V96.0049H65.5899V95.0713Z",
    fill: "#FAFAFA"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 96.6489H64.6489V97.5825H65.5899V96.6489Z",
    fill: "#FAFAFA"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 98.2266H64.6489V99.1602H65.5899V98.2266Z",
    fill: "#FAFAFA"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 99.772H64.6489V100.706H65.5899V99.772Z",
    fill: "#FAFAFA"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 101.349H64.6489V102.283H65.5899V101.349Z",
    fill: "#FAFAFA"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 102.895H64.6489V103.828H65.5899V102.895Z",
    fill: "#FAFAFA"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 104.472H64.6489V105.406H65.5899V104.472Z",
    fill: "#FAFAFA"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 106.018H64.6489V106.951H65.5899V106.018Z",
    fill: "#FAFAFA"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 107.595H64.6489V108.528H65.5899V107.595Z",
    fill: "#FAFAFA"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 110.718H64.6489V111.651H65.5899V110.718Z",
    fill: "#FAFAFA"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 112.263H64.6489V113.196H65.5899V112.263Z",
    fill: "#FAFAFA"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 113.84H64.6489V114.774H65.5899V113.84Z",
    fill: "#FAFAFA"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 115.386H64.6489V116.319H65.5899V115.386Z",
    fill: "#FAFAFA"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5899 118.508H64.6489V119.442H65.5899V118.508Z",
    fill: "#FAFAFA"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 103.828H56.2773V104.762H57.2183V103.828Z",
    fill: "#FAFAFA"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 105.406H56.2773V106.339H57.2183V105.406Z",
    fill: "#FAFAFA"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 106.951H56.2773V107.885H57.2183V106.951Z",
    fill: "#FAFAFA"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 108.528H56.2773V109.462H57.2183V108.528Z",
    fill: "#FAFAFA"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 110.074H56.2773V111.007H57.2183V110.074Z",
    fill: "#FAFAFA"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 111.651H56.2773V112.585H57.2183V111.651Z",
    fill: "#FAFAFA"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 113.197H56.2773V114.13H57.2183V113.197Z",
    fill: "#FAFAFA"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 116.319H56.2773V117.253H57.2183V116.319Z",
    fill: "#FAFAFA"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 117.897H56.2773V118.831H57.2183V117.897Z",
    fill: "#FAFAFA"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 119.442H56.2773V120.376H57.2183V119.442Z",
    fill: "#FAFAFA"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 121.02H56.2773V121.953H57.2183V121.02Z",
    fill: "#FAFAFA"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 122.565H56.2773V123.499H57.2183V122.565Z",
    fill: "#FAFAFA"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 124.143H56.2773V125.076H57.2183V124.143Z",
    fill: "#FAFAFA"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 125.72H56.2773V126.653H57.2183V125.72Z",
    fill: "#FAFAFA"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2183 127.265H56.2773V128.199H57.2183V127.265Z",
    fill: "#FAFAFA"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 103.828H57.77V104.762H58.711V103.828Z",
    fill: "#FAFAFA"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 105.406H57.77V106.339H58.711V105.406Z",
    fill: "#FAFAFA"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 106.951H57.77V107.885H58.711V106.951Z",
    fill: "#FAFAFA"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 108.528H57.77V109.462H58.711V108.528Z",
    fill: "#FAFAFA"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 110.074H57.77V111.007H58.711V110.074Z",
    fill: "#FAFAFA"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 111.651H57.77V112.585H58.711V111.651Z",
    fill: "#FAFAFA"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 116.319H57.77V117.253H58.711V116.319Z",
    fill: "#FAFAFA"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 117.897H57.77V118.831H58.711V117.897Z",
    fill: "#FAFAFA"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 119.442H57.77V120.376H58.711V119.442Z",
    fill: "#FAFAFA"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 121.02H57.77V121.953H58.711V121.02Z",
    fill: "#FAFAFA"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 122.565H57.77V123.499H58.711V122.565Z",
    fill: "#FAFAFA"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 124.143H57.77V125.076H58.711V124.143Z",
    fill: "#FAFAFA"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 125.72H57.77V126.653H58.711V125.72Z",
    fill: "#FAFAFA"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 127.265H57.77V128.199H58.711V127.265Z",
    fill: "#FAFAFA"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 103.828H59.2302V104.762H60.1712V103.828Z",
    fill: "#FAFAFA"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 105.406H59.2302V106.339H60.1712V105.406Z",
    fill: "#FAFAFA"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 106.951H59.2302V107.885H60.1712V106.951Z",
    fill: "#FAFAFA"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 108.528H59.2302V109.462H60.1712V108.528Z",
    fill: "#FAFAFA"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 110.074H59.2302V111.007H60.1712V110.074Z",
    fill: "#FAFAFA"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 111.651H59.2302V112.585H60.1712V111.651Z",
    fill: "#FAFAFA"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 114.774H59.2302V115.708H60.1712V114.774Z",
    fill: "#FAFAFA"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 116.319H59.2302V117.253H60.1712V116.319Z",
    fill: "#FAFAFA"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 117.897H59.2302V118.831H60.1712V117.897Z",
    fill: "#FAFAFA"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 119.442H59.2302V120.376H60.1712V119.442Z",
    fill: "#FAFAFA"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 121.02H59.2302V121.953H60.1712V121.02Z",
    fill: "#FAFAFA"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 122.565H59.2302V123.499H60.1712V122.565Z",
    fill: "#FAFAFA"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 124.143H59.2302V125.076H60.1712V124.143Z",
    fill: "#FAFAFA"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 125.72H59.2302V126.653H60.1712V125.72Z",
    fill: "#FAFAFA"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 127.265H59.2302V128.199H60.1712V127.265Z",
    fill: "#FAFAFA"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 95.0713H90.6726V96.0049H91.6136V95.0713Z",
    fill: "#FAFAFA"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 96.6489H90.6726V97.5825H91.6136V96.6489Z",
    fill: "#FAFAFA"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 98.2266H90.6726V99.1602H91.6136V98.2266Z",
    fill: "#FAFAFA"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 99.772H90.6726V100.706H91.6136V99.772Z",
    fill: "#FAFAFA"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 101.349H90.6726V102.283H91.6136V101.349Z",
    fill: "#FAFAFA"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 102.895H90.6726V103.828H91.6136V102.895Z",
    fill: "#FAFAFA"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 104.472H90.6726V105.406H91.6136V104.472Z",
    fill: "#FAFAFA"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 106.018H90.6726V106.951H91.6136V106.018Z",
    fill: "#FAFAFA"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 107.595H90.6726V108.528H91.6136V107.595Z",
    fill: "#FAFAFA"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 109.14H90.6726V110.074H91.6136V109.14Z",
    fill: "#FAFAFA"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 110.718H90.6726V111.651H91.6136V110.718Z",
    fill: "#FAFAFA"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 112.263H90.6726V113.196H91.6136V112.263Z",
    fill: "#FAFAFA"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 113.84H90.6726V114.774H91.6136V113.84Z",
    fill: "#FAFAFA"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 116.963H90.6726V117.897H91.6136V116.963Z",
    fill: "#FAFAFA"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 118.508H90.6726V119.442H91.6136V118.508Z",
    fill: "#FAFAFA"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 120.086H90.6726V121.02H91.6136V120.086Z",
    fill: "#FAFAFA"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 121.664H90.6726V122.597H91.6136V121.664Z",
    fill: "#FAFAFA"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 124.786H90.6726V125.72H91.6136V124.786Z",
    fill: "#FAFAFA"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 126.332H90.6726V127.265H91.6136V126.332Z",
    fill: "#FAFAFA"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 127.909H90.6726V128.843H91.6136V127.909Z",
    fill: "#FAFAFA"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 95.0713H92.1653V96.0049H93.1063V95.0713Z",
    fill: "#FAFAFA"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 96.6489H92.1653V97.5825H93.1063V96.6489Z",
    fill: "#FAFAFA"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 98.2266H92.1653V99.1602H93.1063V98.2266Z",
    fill: "#FAFAFA"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 99.772H92.1653V100.706H93.1063V99.772Z",
    fill: "#FAFAFA"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 101.349H92.1653V102.283H93.1063V101.349Z",
    fill: "#FAFAFA"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 102.895H92.1653V103.828H93.1063V102.895Z",
    fill: "#FAFAFA"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 104.472H92.1653V105.406H93.1063V104.472Z",
    fill: "#FAFAFA"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 106.018H92.1653V106.951H93.1063V106.018Z",
    fill: "#FAFAFA"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 107.595H92.1653V108.528H93.1063V107.595Z",
    fill: "#FAFAFA"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 109.14H92.1653V110.074H93.1063V109.14Z",
    fill: "#FAFAFA"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 110.718H92.1653V111.651H93.1063V110.718Z",
    fill: "#FAFAFA"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 112.263H92.1653V113.196H93.1063V112.263Z",
    fill: "#FAFAFA"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 113.84H92.1653V114.774H93.1063V113.84Z",
    fill: "#FAFAFA"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 118.508H92.1653V119.442H93.1063V118.508Z",
    fill: "#FAFAFA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 120.086H92.1653V121.02H93.1063V120.086Z",
    fill: "#FAFAFA"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 123.209H92.1653V124.143H93.1063V123.209Z",
    fill: "#FAFAFA"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 124.786H92.1653V125.72H93.1063V124.786Z",
    fill: "#FAFAFA"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 126.332H92.1653V127.265H93.1063V126.332Z",
    fill: "#FAFAFA"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1063 127.909H92.1653V128.843H93.1063V127.909Z",
    fill: "#FAFAFA"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 95.0713H93.658V96.0049H94.599V95.0713Z",
    fill: "#FAFAFA"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 96.6489H93.658V97.5825H94.599V96.6489Z",
    fill: "#FAFAFA"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 98.2266H93.658V99.1602H94.599V98.2266Z",
    fill: "#FAFAFA"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 99.772H93.658V100.706H94.599V99.772Z",
    fill: "#FAFAFA"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 101.349H93.658V102.283H94.599V101.349Z",
    fill: "#FAFAFA"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 102.895H93.658V103.828H94.599V102.895Z",
    fill: "#FAFAFA"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 104.472H93.658V105.406H94.599V104.472Z",
    fill: "#FAFAFA"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 106.018H93.658V106.951H94.599V106.018Z",
    fill: "#FAFAFA"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 107.595H93.658V108.528H94.599V107.595Z",
    fill: "#FAFAFA"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 109.14H93.658V110.074H94.599V109.14Z",
    fill: "#FAFAFA"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 110.718H93.658V111.651H94.599V110.718Z",
    fill: "#FAFAFA"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 112.263H93.658V113.196H94.599V112.263Z",
    fill: "#FAFAFA"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 113.84H93.658V114.774H94.599V113.84Z",
    fill: "#FAFAFA"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 115.386H93.658V116.319H94.599V115.386Z",
    fill: "#FAFAFA"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 118.508H93.658V119.442H94.599V118.508Z",
    fill: "#FAFAFA"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 121.664H93.658V122.597H94.599V121.664Z",
    fill: "#FAFAFA"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 123.209H93.658V124.143H94.599V123.209Z",
    fill: "#FAFAFA"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 124.786H93.658V125.72H94.599V124.786Z",
    fill: "#FAFAFA"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 126.332H93.658V127.265H94.599V126.332Z",
    fill: "#FAFAFA"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M94.599 127.909H93.658V128.843H94.599V127.909Z",
    fill: "#FAFAFA"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 103.989H84.6047V104.923H85.5457V103.989Z",
    fill: "#FAFAFA"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 105.566H84.6047V106.5H85.5457V105.566Z",
    fill: "#FAFAFA"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 107.112H84.6047V108.045H85.5457V107.112Z",
    fill: "#FAFAFA"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 108.689H84.6047V109.623H85.5457V108.689Z",
    fill: "#FAFAFA"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 110.235H84.6047V111.168H85.5457V110.235Z",
    fill: "#FAFAFA"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 111.812H84.6047V112.746H85.5457V111.812Z",
    fill: "#FAFAFA"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 116.48H84.6047V117.414H85.5457V116.48Z",
    fill: "#FAFAFA"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 118.058H84.6047V118.991H85.5457V118.058Z",
    fill: "#FAFAFA"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 119.603H84.6047V120.537H85.5457V119.603Z",
    fill: "#FAFAFA"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 121.181H84.6047V122.114H85.5457V121.181Z",
    fill: "#FAFAFA"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 122.758H84.6047V123.692H85.5457V122.758Z",
    fill: "#FAFAFA"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 124.303H84.6047V125.237H85.5457V124.303Z",
    fill: "#FAFAFA"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5457 125.881H84.6047V126.814H85.5457V125.881Z",
    fill: "#FAFAFA"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 103.989H86.0974V104.923H87.0384V103.989Z",
    fill: "#FAFAFA"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 105.566H86.0974V106.5H87.0384V105.566Z",
    fill: "#FAFAFA"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 107.112H86.0974V108.045H87.0384V107.112Z",
    fill: "#FAFAFA"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 108.689H86.0974V109.623H87.0384V108.689Z",
    fill: "#FAFAFA"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 110.235H86.0974V111.168H87.0384V110.235Z",
    fill: "#FAFAFA"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 111.812H86.0974V112.746H87.0384V111.812Z",
    fill: "#FAFAFA"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 116.48H86.0974V117.414H87.0384V116.48Z",
    fill: "#FAFAFA"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 118.058H86.0974V118.991H87.0384V118.058Z",
    fill: "#FAFAFA"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 119.603H86.0974V120.537H87.0384V119.603Z",
    fill: "#FAFAFA"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 121.181H86.0974V122.114H87.0384V121.181Z",
    fill: "#FAFAFA"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 122.758H86.0974V123.692H87.0384V122.758Z",
    fill: "#FAFAFA"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 124.303H86.0974V125.237H87.0384V124.303Z",
    fill: "#FAFAFA"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 127.426H86.0974V128.36H87.0384V127.426Z",
    fill: "#FAFAFA"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 97.0996H135.678V98.0332H136.619V97.0996Z",
    fill: "#FAFAFA"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 98.6772H135.678V99.6109H136.619V98.6772Z",
    fill: "#FAFAFA"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 100.255H135.678V101.188H136.619V100.255Z",
    fill: "#FAFAFA"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 101.8H135.678V102.733H136.619V101.8Z",
    fill: "#FAFAFA"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 103.377H135.678V104.311H136.619V103.377Z",
    fill: "#FAFAFA"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 104.923H135.678V105.856H136.619V104.923Z",
    fill: "#FAFAFA"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 106.5H135.678V107.434H136.619V106.5Z",
    fill: "#FAFAFA"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 108.045H135.678V108.979H136.619V108.045Z",
    fill: "#FAFAFA"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 109.623H135.678V110.557H136.619V109.623Z",
    fill: "#FAFAFA"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 111.168H135.678V112.102H136.619V111.168Z",
    fill: "#FAFAFA"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 112.746H135.678V113.679H136.619V112.746Z",
    fill: "#FAFAFA"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 115.869H135.678V116.802H136.619V115.869Z",
    fill: "#FAFAFA"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 117.414H135.678V118.348H136.619V117.414Z",
    fill: "#FAFAFA"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 118.991H135.678V119.925H136.619V118.991Z",
    fill: "#FAFAFA"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 120.537H135.678V121.47H136.619V120.537Z",
    fill: "#FAFAFA"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 122.114H135.678V123.048H136.619V122.114Z",
    fill: "#FAFAFA"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 123.692H135.678V124.626H136.619V123.692Z",
    fill: "#FAFAFA"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 125.237H135.678V126.17H136.619V125.237Z",
    fill: "#FAFAFA"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M136.619 126.814H135.678V127.748H136.619V126.814Z",
    fill: "#FAFAFA"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 97.0996H137.139V98.0332H138.08V97.0996Z",
    fill: "#FAFAFA"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 98.6772H137.139V99.6109H138.08V98.6772Z",
    fill: "#FAFAFA"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 100.255H137.139V101.188H138.08V100.255Z",
    fill: "#FAFAFA"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 101.8H137.139V102.733H138.08V101.8Z",
    fill: "#FAFAFA"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 103.377H137.139V104.311H138.08V103.377Z",
    fill: "#FAFAFA"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 104.923H137.139V105.856H138.08V104.923Z",
    fill: "#FAFAFA"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 106.5H137.139V107.434H138.08V106.5Z",
    fill: "#FAFAFA"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 108.045H137.139V108.979H138.08V108.045Z",
    fill: "#FAFAFA"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 109.623H137.139V110.557H138.08V109.623Z",
    fill: "#FAFAFA"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 111.168H137.139V112.102H138.08V111.168Z",
    fill: "#FAFAFA"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 112.746H137.139V113.679H138.08V112.746Z",
    fill: "#FAFAFA"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 114.291H137.139V115.225H138.08V114.291Z",
    fill: "#FAFAFA"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 115.869H137.139V116.802H138.08V115.869Z",
    fill: "#FAFAFA"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 117.414H137.139V118.348H138.08V117.414Z",
    fill: "#FAFAFA"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 118.991H137.139V119.925H138.08V118.991Z",
    fill: "#FAFAFA"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 120.537H137.139V121.47H138.08V120.537Z",
    fill: "#FAFAFA"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 122.114H137.139V123.048H138.08V122.114Z",
    fill: "#FAFAFA"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 123.692H137.139V124.626H138.08V123.692Z",
    fill: "#FAFAFA"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 125.237H137.139V126.17H138.08V125.237Z",
    fill: "#FAFAFA"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 126.814H137.139V127.748H138.08V126.814Z",
    fill: "#FAFAFA"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 103.216H128.313V104.15H129.254V103.216Z",
    fill: "#FAFAFA"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 104.762H128.313V105.695H129.254V104.762Z",
    fill: "#FAFAFA"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 106.339H128.313V107.273H129.254V106.339Z",
    fill: "#FAFAFA"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 107.885H128.313V108.818H129.254V107.885Z",
    fill: "#FAFAFA"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 109.462H128.313V110.396H129.254V109.462Z",
    fill: "#FAFAFA"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 111.007H128.313V111.941H129.254V111.007Z",
    fill: "#FAFAFA"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 112.585H128.313V113.519H129.254V112.585Z",
    fill: "#FAFAFA"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 114.13H128.313V115.064H129.254V114.13Z",
    fill: "#FAFAFA"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 115.708H128.313V116.641H129.254V115.708Z",
    fill: "#FAFAFA"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 117.253H128.313V118.187H129.254V117.253Z",
    fill: "#FAFAFA"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 103.216H129.805V104.15H130.746V103.216Z",
    fill: "#FAFAFA"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 104.762H129.805V105.695H130.746V104.762Z",
    fill: "#FAFAFA"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 106.339H129.805V107.273H130.746V106.339Z",
    fill: "#FAFAFA"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 107.885H129.805V108.818H130.746V107.885Z",
    fill: "#FAFAFA"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 109.462H129.805V110.396H130.746V109.462Z",
    fill: "#FAFAFA"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 111.007H129.805V111.941H130.746V111.007Z",
    fill: "#FAFAFA"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 112.585H129.805V113.519H130.746V112.585Z",
    fill: "#FAFAFA"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 114.13H129.805V115.064H130.746V114.13Z",
    fill: "#FAFAFA"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M130.746 115.708H129.805V116.641H130.746V115.708Z",
    fill: "#FAFAFA"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M132.92 62.1372C132.92 61.2036 133.699 60.4309 134.64 60.4309C134.802 60.4309 134.964 60.4631 135.127 60.4953C135.094 60.3344 135.094 60.1412 135.094 59.9802C135.094 57.9842 136.717 56.4067 138.696 56.4067C138.923 56.4067 139.15 56.4389 139.377 56.4711C139.929 55.5697 140.935 54.958 142.071 54.958C143.79 54.958 145.218 56.3423 145.218 58.0486C145.251 58.0486 145.251 58.0486 145.283 58.0486C146.905 58.0486 148.203 59.3364 148.203 60.946C148.203 62.5557 146.905 63.8435 145.283 63.8435H134.607C133.666 63.8113 132.92 63.0386 132.92 62.1372Z",
    fill: "#FAFAFA"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9114 59.5619H53.6813C53.7137 59.4009 53.7137 59.2721 53.7137 59.1111C53.7137 56.8576 51.8642 55.0547 49.6252 55.0547C49.5603 55.0547 49.5279 55.0547 49.463 55.0547C48.9438 53.7026 47.6134 52.7046 46.0559 52.7046C44.0441 52.7046 42.4217 54.3143 42.4217 56.3103C40.637 56.4069 39.2417 57.7912 39.1444 59.5619H38.9821C37.9762 59.5619 37.165 60.3667 37.165 61.3647C37.165 62.3627 37.9762 63.1676 38.9821 63.1676H59.9114C60.9172 63.1676 61.7285 62.3627 61.7285 61.3647C61.7285 60.3667 60.9172 59.5619 59.9114 59.5619Z",
    fill: "#FAFAFA"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M104.074 40.2454C102.743 38.1206 100.374 36.7041 97.6488 36.7041C94.8907 36.7041 92.4895 38.1528 91.1591 40.342C90.8022 40.2454 90.4452 40.181 90.0559 40.181C87.8169 40.181 85.9998 41.9839 85.9998 44.2052H83.8582C82.755 44.2052 81.814 45.1067 81.814 46.2334C81.814 47.328 82.7225 48.2617 83.8582 48.2617H91.2564C92.5868 50.3542 94.9556 51.7708 97.6488 51.7708C99.7579 51.7708 101.672 50.9015 103.068 49.5172C103.197 49.5172 103.327 49.5494 103.457 49.5494C106.053 49.5494 108.162 47.4568 108.162 44.8813C108.162 42.499 106.377 40.5673 104.074 40.2454Z",
    fill: "#FAFAFA"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2299 137.246C126.978 137.246 155.147 135.617 155.147 133.608C155.147 131.598 126.978 129.97 92.2299 129.97C57.4816 129.97 29.3125 131.598 29.3125 133.608C29.3125 135.617 57.4816 137.246 92.2299 137.246Z",
    fill: "#F5F5F5"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M16 134H165.5",
    stroke: "black"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M95.0207 132.867L94.5664 133.608L94.9233 130.775L95.2478 130.453C95.475 131.483 95.0207 132.867 95.0207 132.867Z",
    fill: "black"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.0119 132.448L65.5576 132.674L58.5163 126.171L51.4101 119.635C51.4101 119.635 52.3186 117.317 52.124 115.836C51.9617 114.356 53.2597 112.746 53.2597 112.746L54.947 107.691L53.4219 109.494L53.2272 111.104L50.8909 114.098L48.9765 117.993C48.9765 117.993 48.1977 117.253 47.062 116.094C47.3865 115.74 47.6785 115.354 47.9706 114.967C48.5871 114.195 49.2361 113.454 49.9175 112.746C50.5989 112.005 51.3776 111.297 52.0591 110.524C52.2538 110.331 52.416 110.106 52.5133 109.848C52.6107 109.623 52.6107 109.366 52.6756 109.14C52.8703 108.367 53.5841 107.917 54.1358 107.369C54.4602 107.08 54.7198 106.726 55.0119 106.404C55.3363 106.05 55.6608 105.728 56.0178 105.406C56.6667 104.762 57.3157 104.086 57.9647 103.442L57.9971 103.41C61.6962 106.146 65.5576 108.979 69.062 111.555C76.3953 116.931 82.3658 121.277 82.593 121.342L88.0119 132.448Z",
    fill: "black"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2921 132.771C62.2479 130.034 59.2626 127.813 64.9411 123.145C70.5871 118.444 60.593 115 62.8644 110.138C65.1358 105.277 69.9381 106.275 68.0886 101.961C66.239 97.6472 61.534 97.6472 63.4809 93.7518C65.4278 89.8563 61.6313 86.3794 61.6313 86.3794C61.6313 86.3794 65.1682 88.8905 65.0709 91.3372C64.9735 93.8161 63.6107 94.621 66.0443 96.6814C68.478 98.7418 72.3393 101.446 71.9499 103.989C71.5281 106.533 72.6638 110.46 74.5782 108.754C76.4603 107.08 80.9706 107.08 84.0207 110.042C87.0709 113.036 86.5193 131.676 86.5193 131.676L64.2921 132.771Z",
    fill: "#263238"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M64.2921 132.771C62.2479 130.034 59.2626 127.813 64.9411 123.145C70.5871 118.444 60.593 115 62.8644 110.138C65.1358 105.277 69.9381 106.275 68.0886 101.961C66.239 97.6472 61.534 97.6472 63.4809 93.7518C65.4278 89.8563 61.6313 86.3794 61.6313 86.3794C61.6313 86.3794 65.1682 88.8905 65.0709 91.3372C64.9735 93.8161 63.6107 94.621 66.0443 96.6814C68.478 98.7418 72.3393 101.446 71.9499 103.989C71.5281 106.533 72.6638 110.46 74.5782 108.754C76.4603 107.08 80.9706 107.08 84.0207 110.042C87.0709 113.036 86.5193 131.676 86.5193 131.676L64.2921 132.771Z",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.2921 130.871C62.5723 128.199 63.9027 122.855 68.9971 120.569C74.0915 118.283 76.1033 122.082 76.1033 122.082C76.1033 122.082 74.3511 117.543 70.3275 118.992C70.3275 118.992 69.1593 115.128 72.3717 113.261C72.3717 113.261 69.0295 114.871 69.0295 117.736C69.0295 117.736 66.3039 118.283 65.59 114.678C64.8761 111.04 68.9646 108.979 71.1387 109.591C71.1387 109.591 68.3481 107.627 65.59 107.917C65.59 107.917 68.0236 104.601 70.5222 106.146C73.0207 107.692 72.2744 109.977 72.2744 109.977L73.6696 110.847C73.6696 110.847 76.3304 108.207 79.0236 108.979C81.7168 109.752 84.767 119.281 81.295 122.308C81.295 122.308 87.7522 128.714 81.295 130.903C74.8378 133.092 64.2921 130.871 64.2921 130.871Z",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M99.3363 133.608H80.6785C79.121 127.201 76.4278 115.289 74.3511 101.736C77.9204 101.929 84.3452 102.766 90.5104 105.953C93.236 114.034 96.1888 123.241 99.3363 133.608Z",
    fill: "black"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M73.832 133.607L75.7789 128.36C75.7789 128.36 81.2952 129.937 81.8143 130.098C82.3335 130.259 84.3453 130.324 84.4102 130.871C84.4751 131.418 88.0769 132.577 88.0769 132.577L88.8881 130.356C88.8881 130.356 91.9058 130.71 92.4249 130.774C92.9766 130.839 95.4751 131.837 95.4751 131.837L97.9736 128.36L102.03 131.225C102.03 131.225 106.41 133.607 105.859 133.64C105.307 133.607 73.832 133.607 73.832 133.607Z",
    fill: "#2F456C"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.832 133.607L75.7789 128.36C75.7789 128.36 81.2952 129.937 81.8143 130.098C82.3335 130.259 84.3453 130.324 84.4102 130.871C84.4751 131.418 88.0769 132.577 88.0769 132.577L88.8881 130.356C88.8881 130.356 91.9058 130.71 92.4249 130.774C92.9766 130.839 95.4751 131.837 95.4751 131.837L97.9736 128.36L102.03 131.225C102.03 131.225 106.41 133.607 105.859 133.64C105.307 133.607 73.832 133.607 73.832 133.607Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7288 133.608L67.4397 129.004L73.7022 131.773L77.1417 133.608H61.7288Z",
    fill: "#2F456C"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.7288 133.608L67.4397 129.004L73.7022 131.773L77.1417 133.608H61.7288Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M114.717 125.301C112.38 118.251 115.431 114.613 120.006 114.999C124.581 115.418 126.074 109.526 122.082 106.468C118.091 103.409 118.903 101.768 120.525 101.156C122.18 100.576 122.115 95.5542 119.357 94.6206C116.599 93.6869 115.788 90.371 119.746 89.3086C119.746 89.3086 116.436 90.7895 118.221 92.3992C120.752 94.6849 128.053 96.4878 125.879 100.158C123.705 103.828 121.563 104.762 125.198 106.082C128.832 107.434 136.976 117.832 131.265 120.472C131.265 120.472 136.392 124.464 133.667 129.422C130.941 134.38 125.068 133.446 125.068 133.446L114.717 125.301Z",
    fill: "#263238"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M114.717 125.301C112.38 118.251 115.431 114.613 120.006 114.999C124.581 115.418 126.074 109.526 122.082 106.468C118.091 103.409 118.903 101.768 120.525 101.156C122.18 100.576 122.115 95.5542 119.357 94.6206C116.599 93.6869 115.788 90.371 119.746 89.3086C119.746 89.3086 116.436 90.7895 118.221 92.3992C120.752 94.6849 128.053 96.4878 125.879 100.158C123.705 103.828 121.563 104.762 125.198 106.082C128.832 107.434 136.976 117.832 131.265 120.472C131.265 120.472 136.392 124.464 133.667 129.422C130.941 134.38 125.068 133.446 125.068 133.446L114.717 125.301Z",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.717 123.369C115.171 116.802 116.177 116.77 120.525 116.931C124.873 117.092 125.003 120.15 125.003 120.15C125.003 120.15 121.888 119.152 120.525 120.15C120.525 120.15 127.793 120.408 128.605 124.142C128.605 124.142 128.67 121.728 126.852 120.955C126.852 120.955 129.968 119.571 131.979 124.142C134.024 128.714 129.74 132.738 125.035 130.516C120.298 128.295 114.717 123.369 114.717 123.369Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.991 115.74C123.38 115.643 126.593 116.834 126.398 119.12C126.398 119.12 129.61 119.184 130.422 119.861C130.422 119.861 132.369 119.539 131.525 116.545C130.681 113.551 127.079 112.939 127.079 112.939C127.079 112.939 129.026 112.263 129.87 112.907C130.714 113.551 130.422 112.617 130.422 112.617C130.422 112.617 128.41 109.784 127.371 109.172C126.333 108.528 125.197 108.754 125.197 108.754C125.197 108.754 125.068 107.402 126.787 108.013C126.787 108.013 125.197 106.5 124.256 108.754C124.256 108.754 125.489 110.331 125.587 111.49C125.587 111.49 127.112 110.621 127.988 111.104C127.988 111.104 125.327 112.488 125.035 113.422C124.743 114.355 125.197 114.967 125.197 114.967C125.197 114.967 126.982 114.452 127.696 116.866C127.696 116.866 126.495 115.45 124.256 115.45C123.023 115.482 122.991 115.74 122.991 115.74Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M103.879 121.18L101.023 126.299L100.504 129.583C100.504 129.583 100.115 130.549 98.9792 130.549C97.8435 130.549 97.0972 130.066 97.1621 131.096C97.227 132.126 94.9556 133.382 94.9556 133.382H126.333L115.658 123.08L103.879 121.18Z",
    fill: "#263238"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.549 133.124L104.171 130.967L107.773 131.579L108.973 133.124L109.687 132.802L110.596 129.647L116.501 128.134L124.127 132.577L124.516 133.414H101.51L102.549 133.124Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.501 125.591C116.112 125.398 112.056 126.557 111.731 126.396C111.439 126.235 110.726 125.43 110.563 125.591C110.369 125.752 108.941 125.591 108.941 125.591L107.124 126.653L106.669 129.615L106.15 128.456V126.653C106.15 126.653 106.345 125.333 105.793 125.591C105.242 125.848 104.852 125.591 104.852 125.591L104.139 126.492L103.911 128.102L102.841 127.651V122.404L108.941 120.44L116.501 124.271V125.591Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M121.109 133.092C121.109 133.092 123.446 131.45 123.738 131.579C124.03 131.708 124.873 131.997 125.62 132.223C126.366 132.48 127.372 133.06 127.372 133.06C127.372 133.06 128.248 132.996 128.637 133.06C129.027 133.124 131.233 133.575 131.233 133.575H119.682L121.109 133.092Z",
    fill: "#2F456C"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M113.581 133.607L116.631 130.581L115.853 129.036L108.162 133.607H113.581Z",
    fill: "#2F456C"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M121.109 133.092C121.109 133.092 123.446 131.45 123.738 131.579C124.03 131.708 124.873 131.997 125.62 132.223C126.366 132.48 127.372 133.06 127.372 133.06C127.372 133.06 128.248 132.996 128.637 133.06C129.027 133.124 131.233 133.575 131.233 133.575H119.682L121.109 133.092Z",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.581 133.607L116.631 130.581L115.853 129.036L108.162 133.607H113.581Z",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M115.041 133.607H120.785L119.454 132.03L115.528 131.547H113.354L111.667 133.607H115.041Z",
    fill: "#2F456C"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8704 132.319L97.5518 130.259C97.5518 130.259 98.5577 129.325 98.9146 129.551C99.2391 129.744 102.549 131.643 102.549 131.643L108.876 132.738L110.239 133.575H97.6491L96.8704 132.319Z",
    fill: "#2F456C"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.041 133.607H120.785L119.454 132.03L115.528 131.547H113.354L111.667 133.607H115.041Z",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.8704 132.319L97.5518 130.259C97.5518 130.259 98.5577 129.325 98.9146 129.551C99.2391 129.744 102.549 131.643 102.549 131.643L108.876 132.738L110.239 133.575H97.6491L96.8704 132.319Z",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3749 113.454C89.3749 113.454 85.0592 107.08 92.8469 105.76C100.667 104.44 103.652 100.737 99.3365 98.0976C95.0209 95.4577 99.5312 91.2403 100.894 91.1759C102.257 91.1437 108.325 86.1537 102.452 83.0631C96.5784 79.9403 97.8115 74.564 97.8115 74.564C97.8115 74.564 97.9412 79.0389 100.894 80.391C103.847 81.7432 109.331 80.6486 109.98 86.4756C110.629 92.3027 105.599 95.9406 108 96.8098C110.401 97.6791 116.502 108.013 112.997 111.168C109.493 114.323 106.151 112.875 110.856 117.736C115.561 122.629 106.183 132.641 106.183 132.641H86.7141L89.3749 113.454Z",
    fill: "#263238"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.3749 113.454C89.3749 113.454 85.0592 107.08 92.8469 105.76C100.667 104.44 103.652 100.737 99.3365 98.0976C95.0209 95.4577 99.5312 91.2403 100.894 91.1759C102.257 91.1437 108.325 86.1537 102.452 83.0631C96.5784 79.9403 97.8115 74.564 97.8115 74.564C97.8115 74.564 97.9412 79.0389 100.894 80.391C103.847 81.7432 109.331 80.6486 109.98 86.4756C110.629 92.3027 105.599 95.9406 108 96.8098C110.401 97.6791 116.502 108.013 112.997 111.168C109.493 114.323 106.151 112.875 110.856 117.736C115.561 122.629 106.183 132.641 106.183 132.641H86.7141L89.3749 113.454Z",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.7259 111.168C88.7259 111.168 88.5637 108.625 93.5608 107.724C98.5254 106.79 99.2392 112.134 99.2392 112.134C99.2392 112.134 99.4339 108.85 98.1684 107.885C98.1684 107.885 101.121 105.599 104.171 107.885C107.222 110.17 106.313 114.484 106.313 114.484C106.313 114.484 102.873 111.007 97.5519 114.484C97.5519 114.484 105.08 111.522 107.741 116.673C110.401 121.824 107.741 125.14 107.741 125.14C107.741 125.14 103.198 120.955 100.862 122.243C100.862 122.243 100.764 116.416 94.015 116.158C94.0475 116.158 94.9885 111.49 88.7259 111.168Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.7317 118.154C89.7317 118.154 93.593 116.062 97.1948 118.154C100.829 120.247 99.5635 127.265 99.5635 127.265C99.5635 127.265 101.478 125.237 100.861 123.659C100.861 123.659 104.723 122.211 106.118 125.462C107.546 128.714 105.891 132.255 105.599 132.158C105.307 132.03 91.0945 131.16 91.0945 131.16L89.7317 118.154Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.894 105.727C101.867 105.663 107.351 104.085 105.826 100.963C105.826 100.963 108.487 104.601 104.139 106.21C104.139 106.21 108.714 108.689 108.26 112.263C108.26 112.263 111.472 111.039 111.926 107.949C112.381 104.858 111.018 101.703 108.422 101.317C108.422 101.317 109.558 100.641 110.856 101.993C110.856 101.993 109.168 98.3872 107.449 97.6145C105.729 96.8419 103.814 98.9023 103.814 98.9023C103.814 98.9023 103.912 97.0994 105.729 96.8097C105.729 96.8097 105.112 94.2342 103.133 94.0732C103.133 94.0732 103.977 93.6869 104.82 94.5239C104.82 94.5239 108.909 89.5983 107.157 86.3789C107.157 86.3789 107.676 88.2783 106.702 89.6949C105.729 91.1114 102.841 92.045 102.841 92.045C102.841 92.045 103.36 92.1416 103.23 93.1074C103.23 93.1074 102.614 91.5621 100.862 91.884C99.0769 92.1738 99.304 93.7835 99.304 93.7835C99.304 93.7835 100.115 93.2362 101.089 94.0732C101.089 94.0732 98.72 93.0108 98.1359 95.1356C97.5843 97.2604 100.115 98.1296 101.316 97.3248C101.316 97.3248 101.251 96.4555 102.062 96.4555C102.062 96.4555 101.381 96.7453 101.835 97.7433C101.835 97.7433 100.862 98.5159 101.218 99.353C101.543 100.158 102.127 100.126 102.127 100.126C102.127 100.126 103.133 99.2886 103.879 100.126C103.879 100.126 102.808 100.029 101.9 100.963C100.991 101.896 102.581 103.603 102.581 103.603C102.581 103.603 100.764 105.148 98.2332 105.599C98.2332 105.599 100.342 105.695 102.484 104.762L100.894 105.727Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0681 117.51C92.2304 117.542 95.4752 115.128 95.4752 115.128L96.6109 116.995L95.0209 122.661L96.2215 124.722L96.0593 127.748L98.5578 128.681L98.9472 130.13L101.478 130.806L102.192 131.354L103.62 132.158H104.593L107.773 133.221H55.8557L89.7967 116.673L92.0681 117.51Z",
    fill: "#263238"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3897 132.963C97.3897 132.963 97.9089 124.754 94.6316 116.995L95.1508 116.287C95.1508 116.287 98.2009 121.535 98.2009 132.963H97.3897Z",
    fill: "#263238"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.3897 132.963C97.3897 132.963 97.9089 124.754 94.6316 116.995L95.1508 116.287C95.1508 116.287 98.2009 121.535 98.2009 132.963H97.3897Z",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3071 109.43C83.3071 109.43 92.6522 108.754 98.9147 109.72L98.3631 110.074C98.3631 110.074 86.6493 110.074 84.0534 110.557C81.4251 111.007 83.3071 109.43 83.3071 109.43Z",
    fill: "#263238"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.3071 109.43C83.3071 109.43 92.6522 108.754 98.9147 109.72L98.3631 110.074C98.3631 110.074 86.6493 110.074 84.0534 110.557C81.4251 111.007 83.3071 109.43 83.3071 109.43Z",
    fill: "white"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M87.655 129.197L95.0533 126.557L100.505 119.796L100.894 120.505L95.7347 127.233L86.6167 132.352L87.655 129.197Z",
    fill: "#263238"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.655 129.197L95.0533 126.557L100.505 119.796L100.894 120.505L95.7347 127.233L86.6167 132.352L87.655 129.197Z",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3306 112.939L67.1802 114.42L64.3572 121.792C64.3572 121.792 83.7613 120.859 84.9295 120.44C86.0976 120.022 88.8557 119.635 88.7259 118.734C88.5961 117.833 85.0917 110.75 85.0917 110.75C85.0917 110.75 70.2303 110.299 65.3306 112.939Z",
    fill: "#263238"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1683 116.448L64.9736 116.641L65.071 116.609L64.9736 116.835L65.1683 116.641L65.1034 116.835L65.2657 116.545L65.1683 116.448Z",
    fill: "#263238"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6402 116.963C68.5753 116.963 68.5428 116.963 68.4779 116.963C66.8555 116.706 67.3423 113.325 67.3747 113.197L67.6667 113.229C67.6667 113.261 67.18 116.448 68.5428 116.674C68.7375 116.706 68.8998 116.674 69.0945 116.545C70.0355 115.837 70.4248 113.1 70.4248 113.1L70.7169 113.132C70.7169 113.261 70.3275 115.998 69.2892 116.77C69.062 116.899 68.8673 116.963 68.6402 116.963Z",
    fill: "#263238"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2657 116.673L65.0386 116.48C66.2392 115.192 66.2392 113.293 66.2392 113.261H66.5312C66.5312 113.357 66.5312 115.289 65.2657 116.673Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6402 116.963C68.5753 116.963 68.5428 116.963 68.4779 116.963C66.8555 116.706 67.3423 113.325 67.3747 113.197L67.6667 113.229C67.6667 113.261 67.18 116.448 68.5428 116.674C68.7375 116.706 68.8998 116.674 69.0945 116.545C70.0355 115.837 70.4248 113.1 70.4248 113.1L70.7169 113.132C70.7169 113.261 70.3275 115.998 69.2892 116.77C69.062 116.899 68.8673 116.963 68.6402 116.963Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2657 116.673L65.0386 116.48C66.2392 115.192 66.2392 113.293 66.2392 113.261H66.5312C66.5312 113.357 66.5312 115.289 65.2657 116.673Z",
    fill: "white"
  }))), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6609 117.511C66.6285 117.511 66.596 117.511 66.5636 117.511C65.8172 117.317 65.8497 114.356 65.8821 113.454H66.1742C66.1093 115.193 66.2715 117.124 66.6285 117.221C66.6285 117.221 66.6609 117.221 66.6934 117.189C67.1476 116.931 67.7966 114.806 68.0886 113.551L68.3807 113.615C68.3158 113.969 67.5695 116.995 66.8556 117.414C66.7907 117.511 66.6934 117.511 66.6609 117.511Z",
    fill: "#263238"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3601 120.73L70.0681 120.666C70.8144 117.704 69.6787 113.1 69.6462 113.068L69.9383 113.003C70.0032 113.164 71.1389 117.704 70.3601 120.73Z",
    fill: "#263238"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6609 117.511C66.6285 117.511 66.596 117.511 66.5636 117.511C65.8172 117.317 65.8497 114.356 65.8821 113.454H66.1742C66.1093 115.193 66.2715 117.124 66.6285 117.221C66.6285 117.221 66.6609 117.221 66.6934 117.189C67.1476 116.931 67.7966 114.806 68.0886 113.551L68.3807 113.615C68.3158 113.969 67.5695 116.995 66.8556 117.414C66.7907 117.511 66.6934 117.511 66.6609 117.511Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3601 120.73L70.0681 120.666C70.8144 117.704 69.6787 113.1 69.6462 113.068L69.9383 113.003C70.0032 113.164 71.1389 117.704 70.3601 120.73Z",
    fill: "white"
  }))), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M62.605 121.02L62.7997 119.796C62.7997 119.796 63.9029 119.217 64.0003 119.185C64.0976 119.153 65.9472 119.185 65.9472 119.185L66.5961 119.99L66.3365 121.825L62.605 121.02Z",
    fill: "#263238"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.605 121.02L62.7997 119.796C62.7997 119.796 63.9029 119.217 64.0003 119.185C64.0976 119.153 65.9472 119.185 65.9472 119.185L66.5961 119.99L66.3365 121.825L62.605 121.02Z",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.9471 119.185L64.9412 120.054L65.4279 121.631L66.3689 121.824L66.596 119.989L65.9471 119.185Z",
    fill: "black"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6609 121.18L66.7582 119.957C66.7582 119.957 67.829 119.281 67.9264 119.249C68.0237 119.217 69.8733 119.088 69.8733 119.088L70.5871 119.828L70.4898 121.663L66.6609 121.18Z",
    fill: "#263238"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.6609 121.18L66.7582 119.957C66.7582 119.957 67.829 119.281 67.9264 119.249C68.0237 119.217 69.8733 119.088 69.8733 119.088L70.5871 119.828L70.4898 121.663L66.6609 121.18Z",
    fill: "white"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.8084 119.088L68.8999 120.054L66.7258 119.925L67.894 119.249L69.8084 119.088Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5576 113.132C65.5576 113.132 70.5222 111.877 75.2597 112.199L74.4809 120.505C74.4809 120.505 64.065 122.211 59.1978 121.181L60.4632 119.99L61.242 120.666L61.7936 120.376L62.3777 120.634L62.475 120.44L63.1889 120.859L63.0916 120.376L63.773 120.698H64.4868L65.0385 120.601L65.5901 120.086L65.8497 120.344L65.9795 120.601L66.5635 120.698L67.8615 120.666L68.3482 120.505V120.183L68.9972 120.344L70.0031 120.279L70.0355 119.41L71.7228 119.539L72.0473 118.895L72.0798 117.833L72.8585 117.768L72.4367 117.446L73.0208 117.092L73.4101 116.609L73.1181 115.869L73.1506 115.193L73.9618 114.227L72.8585 115.032L72.1771 114.935C72.1771 114.935 72.1122 114.903 72.0798 114.742C72.0473 114.581 72.0473 114.13 72.0473 114.002C72.0473 113.873 72.0798 113.39 72.0798 113.39L71.7553 113.358L71.3983 113.132L71.593 113.873L71.3334 113.551L71.0414 113.261L70.0355 113.744L69.3541 114.774L68.5429 114.935L68.478 113.454L68.1535 114.871L67.245 115.128L66.7907 113.487L65.947 114.678L65.9146 114.195L65.5901 114.259L65.1683 114.613L64.5842 114.452L65.5576 113.132Z",
    fill: "#263238"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.5576 113.132C65.5576 113.132 70.5222 111.877 75.2597 112.199L74.4809 120.505C74.4809 120.505 64.065 122.211 59.1978 121.181L60.4632 119.99L61.242 120.666L61.7936 120.376L62.3777 120.634L62.475 120.44L63.1889 120.859L63.0916 120.376L63.773 120.698H64.4868L65.0385 120.601L65.5901 120.086L65.8497 120.344L65.9795 120.601L66.5635 120.698L67.8615 120.666L68.3482 120.505V120.183L68.9972 120.344L70.0031 120.279L70.0355 119.41L71.7228 119.539L72.0473 118.895L72.0798 117.833L72.8585 117.768L72.4367 117.446L73.0208 117.092L73.4101 116.609L73.1181 115.869L73.1506 115.193L73.9618 114.227L72.8585 115.032L72.1771 114.935C72.1771 114.935 72.1122 114.903 72.0798 114.742C72.0473 114.581 72.0473 114.13 72.0473 114.002C72.0473 113.873 72.0798 113.39 72.0798 113.39L71.7553 113.358L71.3983 113.132L71.593 113.873L71.3334 113.551L71.0414 113.261L70.0355 113.744L69.3541 114.774L68.5429 114.935L68.478 113.454L68.1535 114.871L67.245 115.128L66.7907 113.487L65.947 114.678L65.9146 114.195L65.5901 114.259L65.1683 114.613L64.5842 114.452L65.5576 113.132Z",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6816 114.517L65.2657 114.549L65.5577 114.163V113.647L65.7524 114.098H66.1418V114.291L66.7908 113.519L66.5961 113.197C66.5961 113.197 66.8232 113.519 66.9206 113.454C67.0179 113.39 67.2451 113.197 67.2451 113.197L67.0504 113.519L67.4398 114.935L68.0887 114.742L68.4132 113.454L68.1536 113.293L67.9589 113.454L68.2185 113.132L68.4132 113.293L68.6728 113.132V112.81L68.8999 113.1L69.6787 112.939L68.9324 113.229C68.9324 113.229 68.7701 113.422 68.8026 113.487C68.835 113.551 68.7377 114.678 68.7377 114.678L69.3867 114.581L69.8085 113.712L70.8144 113.197L71.2038 113.036C71.2038 113.036 71.3985 113.326 71.3985 113.293C71.3985 113.229 71.3985 112.81 71.3985 112.81L71.1389 112.617H71.2362H71.5282L71.6256 112.81L71.9825 113.036L72.3719 112.231C72.3719 112.231 68.251 112.424 65.5577 113.1L64.6816 114.517Z",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.4633 119.99L61.2745 120.859L61.1772 121.181L61.4368 120.859L61.8586 120.601L62.4102 120.859L62.2804 121.148L62.5075 121.02L62.6373 121.181V120.794V120.601L63.2863 121.02C63.2863 121.02 63.0916 121.438 63.1241 121.406C63.189 121.342 63.4486 121.116 63.4486 121.116L63.7081 121.277L63.4161 120.859L63.3837 120.698L63.773 120.859V121.084L63.9353 120.859H64.8114V120.923L64.6816 121.116L64.3571 121.277L64.9412 121.148V120.955C64.9412 120.955 65.2332 120.923 65.2657 120.988C65.2657 121.052 65.363 121.181 65.363 121.181V120.859L65.2657 120.794L65.5577 120.472L65.7524 120.537L65.9795 120.859L65.8822 121.213L66.1418 120.859L67.6668 120.923V121.148L67.8291 120.859L68.3483 120.698L68.6727 121.052L68.5754 120.698L68.6727 120.44L68.9972 120.569L69.3217 120.44V120.762L69.484 120.73L69.6462 120.859L69.5813 120.601L69.6462 120.472L70.1005 120.408L70.3925 120.666L70.2303 120.247L70.3925 119.764H71.009L70.4899 121.696L58.2244 122.211L59.1005 121.47L59.2627 121.148L60.4633 119.99Z",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.2656 112.134L81.6521 112.263L82.7553 119.378L75.5518 120.472V118.605L76.3305 119.185L76.8821 117.511L77.1742 119.056L77.3364 117.8L77.596 118.026C77.596 118.026 77.9854 118.67 78.0503 118.702C78.1152 118.734 78.3099 119.249 78.3748 119.024C78.4397 118.831 78.537 117.704 78.537 117.704C78.537 117.704 78.6668 117.736 78.7966 117.833C78.8939 117.929 79.5754 118.38 79.5754 118.38L79.4456 117.317C79.4456 117.317 79.8674 117.382 79.9647 117.478C80.0621 117.575 80.5164 117.317 80.4515 117.221C80.3866 117.124 80.2892 116.641 80.2892 116.641C80.2892 116.641 80.127 116.352 80.3217 116.384C80.4839 116.448 80.6786 116.062 80.6786 116.062C80.6786 116.062 81.0031 116.03 81.068 115.869C81.1653 115.708 81.2951 115.45 81.2951 115.45L80.8733 114.935L81.1978 114.227L80.0621 114.967L80.1919 113.937L80.3217 113.261C80.3217 113.261 79.9972 113.004 79.8998 113.068C79.8025 113.132 79.4456 113.454 79.478 113.615C79.5105 113.744 79.2509 114.034 79.2509 114.034H78.7317L77.9854 113.261L77.8231 114.42L77.3364 113.261L76.3954 114.162L75.8762 113.422L76.2656 112.134Z",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M82.3659 112.295L84.1505 112.424L86.6166 118.444L83.6314 119.185L83.5665 118.026L84.0532 118.348L84.475 117.994H85.0591L85.2862 117.318L84.475 116.867L85.0915 116.835L84.7671 116.448L84.7995 115.74L84.475 114.678L84.0856 115.74L83.7612 114.678L83.5016 115.386L83.1446 115.289L83.1771 113.068L82.9499 113.776L82.2361 113.068L82.3659 112.295Z",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1771 121.792C94.1771 121.728 94.1446 121.696 94.1446 121.631C94.1122 121.567 94.1122 121.503 94.0798 121.47C94.0798 121.47 94.0798 121.47 94.0798 121.438C94.0473 121.374 94.0149 121.342 93.9824 121.277C93.3659 120.376 93.9824 119.796 93.9824 119.796L93.8851 119.185L93.6579 117.639C93.6579 117.639 94.3393 115.676 93.6579 115.128C92.9765 114.581 92.6196 113.873 92.6196 113.873L90.1535 109.752H87.7523L88.1417 108.271C88.1417 108.271 72.1446 108.496 68.3482 110.557C67.4072 111.072 66.3688 111.941 65.298 112.971C66.7582 112.553 69.8733 111.941 75.5517 111.877L74.8379 120.118C68.7051 120.923 61.8585 121.567 58.8084 120.859C58.8084 120.859 58.8084 120.859 58.7759 120.891C58.7435 120.923 58.6137 120.988 58.4839 121.052C58.4514 121.084 58.419 121.084 58.3865 121.116C58.3541 121.148 58.2892 121.181 58.2567 121.213C58.2243 121.245 58.1594 121.277 58.127 121.309C57.8998 121.438 57.5753 121.631 57.2508 121.857C57.0886 121.953 56.9588 122.05 56.7641 122.146C56.7641 122.146 56.4072 122.114 56.0178 122.114C55.9529 122.114 55.9205 122.114 55.8556 122.114C55.7582 122.114 55.6284 122.146 55.5311 122.146C55.4986 122.146 55.4337 122.179 55.4013 122.179C55.4013 122.179 55.4013 122.179 55.3688 122.179C55.3364 122.179 55.3039 122.211 55.239 122.211C55.1417 122.243 55.0768 122.307 55.0119 122.372L54.9795 122.404V122.436C54.9795 122.468 54.947 122.501 54.947 122.565C54.947 122.629 54.947 122.662 54.947 122.726C54.947 122.823 54.947 122.887 54.9146 122.951C54.9146 122.984 54.8821 123.016 54.8821 123.048C54.8821 123.08 54.8821 123.08 54.8497 123.112C54.7523 123.305 54.5576 123.338 54.1034 123.209C54.0709 123.209 54.0385 123.177 53.9736 123.177C53.9411 123.177 53.8762 123.144 53.8438 123.144C53.7789 123.144 53.714 123.144 53.6491 123.144C53.6166 123.144 53.5842 123.144 53.5517 123.144C53.4868 123.144 53.4544 123.177 53.3895 123.177C53.357 123.177 53.3246 123.209 53.3246 123.209C53.2921 123.209 53.2597 123.241 53.2597 123.241C53.1948 123.273 53.1299 123.305 53.065 123.37C53.0326 123.402 53.0326 123.402 53.0001 123.434C52.9677 123.466 52.9352 123.499 52.9028 123.531C52.9028 123.563 52.8703 123.563 52.8703 123.595C52.8379 123.692 52.8054 123.788 52.773 123.885C52.773 123.917 52.773 123.949 52.773 123.982V124.046C52.773 124.078 52.773 124.078 52.773 124.11V124.143C52.773 124.143 52.773 124.175 52.7405 124.175C52.6756 124.303 52.5134 124.464 52.3187 124.593C52.2862 124.625 52.2538 124.625 52.2213 124.658C52.2213 124.658 52.1889 124.658 52.1889 124.69C52.1564 124.722 52.0916 124.754 52.0591 124.786C51.9942 124.819 51.9293 124.851 51.8644 124.883C51.7995 124.915 51.7346 124.947 51.6697 124.98C51.6373 125.012 51.6048 125.012 51.5724 125.012C51.3777 125.108 51.183 125.173 51.0208 125.269C50.9559 125.301 50.9234 125.334 50.8585 125.334C50.6963 125.398 50.5665 125.462 50.5016 125.527L50.4691 125.559C50.3718 125.656 50.2744 125.817 50.1447 126.01C50.1122 126.042 50.1122 126.074 50.0798 126.106L50.0149 126.203C49.7228 126.718 49.4308 127.394 49.2361 127.555C49.1388 127.652 49.0414 127.716 48.9765 127.813L48.9441 127.845C48.7169 128.07 48.5222 128.263 48.36 128.489C48.2951 128.553 48.2302 128.617 48.1653 128.682C48.1653 128.682 48.1653 128.682 48.1329 128.714C48.068 128.778 48.0355 128.843 47.9706 128.907C47.6137 129.326 47.3216 129.744 47.127 130.131C47.0945 130.195 47.0621 130.227 47.0621 130.292C47.0296 130.356 46.9972 130.42 46.9647 130.485C46.9323 130.549 46.9323 130.581 46.8998 130.646V130.678C46.8674 130.742 46.8674 130.807 46.8349 130.871C46.8025 130.935 46.8025 131 46.8025 131.064C46.8025 131.129 46.77 131.161 46.77 131.225V131.257C46.77 131.322 46.77 131.354 46.77 131.418C46.77 131.805 46.8998 132.159 47.1594 132.481L74.6756 133.157L75.4544 133.189L87.2331 133.479L88.1092 131.225L92.5222 127.877V126.235L92.7494 125.849C92.7818 125.784 92.8792 125.656 92.9441 125.495L93.0414 125.334C93.0739 125.301 93.0739 125.237 93.1063 125.205C93.1387 125.141 93.2036 125.044 93.2361 124.98C93.2685 124.947 93.2685 124.915 93.301 124.883L93.3334 124.851C93.3334 124.851 93.3334 124.819 93.3659 124.819C93.3983 124.786 93.3983 124.754 93.3983 124.754C93.4308 124.722 93.4308 124.722 93.4308 124.722L93.8526 124.046C93.95 124.014 94.3718 122.726 94.1771 121.792ZM75.7464 119.99L76.4603 111.845C78.0827 111.845 79.8674 111.877 81.8792 111.973L82.95 118.863C81.0031 119.217 78.4721 119.603 75.7464 119.99ZM83.7936 118.734L82.5281 112.005C83.1122 112.038 83.6963 112.07 84.2803 112.102L86.714 118.187C86.714 118.219 85.6107 118.444 83.7936 118.734Z",
    fill: "#2F456C"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M94.1771 121.792C94.1771 121.728 94.1446 121.696 94.1446 121.631C94.1122 121.567 94.1122 121.503 94.0798 121.47C94.0798 121.47 94.0798 121.47 94.0798 121.438C94.0473 121.374 94.0149 121.342 93.9824 121.277C93.3659 120.376 93.9824 119.796 93.9824 119.796L93.8851 119.185L93.6579 117.639C93.6579 117.639 94.3393 115.676 93.6579 115.128C92.9765 114.581 92.6196 113.873 92.6196 113.873L90.1535 109.752H87.7523L88.1417 108.271C88.1417 108.271 72.1446 108.496 68.3482 110.557C67.4072 111.072 66.3688 111.941 65.298 112.971C66.7582 112.553 69.8733 111.941 75.5517 111.877L74.8379 120.118C68.7051 120.923 61.8585 121.567 58.8084 120.859C58.8084 120.859 58.8084 120.859 58.7759 120.891C58.7435 120.923 58.6137 120.988 58.4839 121.052C58.4514 121.084 58.419 121.084 58.3865 121.116C58.3541 121.148 58.2892 121.181 58.2567 121.213C58.2243 121.245 58.1594 121.277 58.127 121.309C57.8998 121.438 57.5753 121.631 57.2508 121.857C57.0886 121.953 56.9588 122.05 56.7641 122.146C56.7641 122.146 56.4072 122.114 56.0178 122.114C55.9529 122.114 55.9205 122.114 55.8556 122.114C55.7582 122.114 55.6284 122.146 55.5311 122.146C55.4986 122.146 55.4337 122.179 55.4013 122.179C55.4013 122.179 55.4013 122.179 55.3688 122.179C55.3364 122.179 55.3039 122.211 55.239 122.211C55.1417 122.243 55.0768 122.307 55.0119 122.372L54.9795 122.404V122.436C54.9795 122.468 54.947 122.501 54.947 122.565C54.947 122.629 54.947 122.662 54.947 122.726C54.947 122.823 54.947 122.887 54.9146 122.951C54.9146 122.984 54.8821 123.016 54.8821 123.048C54.8821 123.08 54.8821 123.08 54.8497 123.112C54.7523 123.305 54.5576 123.338 54.1034 123.209C54.0709 123.209 54.0385 123.177 53.9736 123.177C53.9411 123.177 53.8762 123.144 53.8438 123.144C53.7789 123.144 53.714 123.144 53.6491 123.144C53.6166 123.144 53.5842 123.144 53.5517 123.144C53.4868 123.144 53.4544 123.177 53.3895 123.177C53.357 123.177 53.3246 123.209 53.3246 123.209C53.2921 123.209 53.2597 123.241 53.2597 123.241C53.1948 123.273 53.1299 123.305 53.065 123.37C53.0326 123.402 53.0326 123.402 53.0001 123.434C52.9677 123.466 52.9352 123.499 52.9028 123.531C52.9028 123.563 52.8703 123.563 52.8703 123.595C52.8379 123.692 52.8054 123.788 52.773 123.885C52.773 123.917 52.773 123.949 52.773 123.982V124.046C52.773 124.078 52.773 124.078 52.773 124.11V124.143C52.773 124.143 52.773 124.175 52.7405 124.175C52.6756 124.303 52.5134 124.464 52.3187 124.593C52.2862 124.625 52.2538 124.625 52.2213 124.658C52.2213 124.658 52.1889 124.658 52.1889 124.69C52.1564 124.722 52.0916 124.754 52.0591 124.786C51.9942 124.819 51.9293 124.851 51.8644 124.883C51.7995 124.915 51.7346 124.947 51.6697 124.98C51.6373 125.012 51.6048 125.012 51.5724 125.012C51.3777 125.108 51.183 125.173 51.0208 125.269C50.9559 125.301 50.9234 125.334 50.8585 125.334C50.6963 125.398 50.5665 125.462 50.5016 125.527L50.4691 125.559C50.3718 125.656 50.2744 125.817 50.1447 126.01C50.1122 126.042 50.1122 126.074 50.0798 126.106L50.0149 126.203C49.7228 126.718 49.4308 127.394 49.2361 127.555C49.1388 127.652 49.0414 127.716 48.9765 127.813L48.9441 127.845C48.7169 128.07 48.5222 128.263 48.36 128.489C48.2951 128.553 48.2302 128.617 48.1653 128.682C48.1653 128.682 48.1653 128.682 48.1329 128.714C48.068 128.778 48.0355 128.843 47.9706 128.907C47.6137 129.326 47.3216 129.744 47.127 130.131C47.0945 130.195 47.0621 130.227 47.0621 130.292C47.0296 130.356 46.9972 130.42 46.9647 130.485C46.9323 130.549 46.9323 130.581 46.8998 130.646V130.678C46.8674 130.742 46.8674 130.807 46.8349 130.871C46.8025 130.935 46.8025 131 46.8025 131.064C46.8025 131.129 46.77 131.161 46.77 131.225V131.257C46.77 131.322 46.77 131.354 46.77 131.418C46.77 131.805 46.8998 132.159 47.1594 132.481L74.6756 133.157L75.4544 133.189L87.2331 133.479L88.1092 131.225L92.5222 127.877V126.235V126.203L92.7494 125.849C92.7818 125.784 92.8792 125.656 92.9441 125.495L93.0414 125.334C93.0739 125.301 93.0739 125.237 93.1063 125.205C93.1387 125.141 93.2036 125.044 93.2361 124.98C93.2685 124.947 93.2685 124.915 93.301 124.883L93.3334 124.851C93.3334 124.851 93.3334 124.819 93.3659 124.819C93.3983 124.786 93.3983 124.754 93.3983 124.754C93.4308 124.722 93.4308 124.722 93.4308 124.722L93.8526 124.046C93.95 124.014 94.3718 122.726 94.1771 121.792ZM75.7464 119.99L76.4603 111.845C78.0827 111.845 79.8674 111.877 81.8792 111.973L82.95 118.863C81.0031 119.217 78.4721 119.603 75.7464 119.99ZM83.7936 118.734L82.5281 112.005C83.1122 112.038 83.6963 112.07 84.2803 112.102L86.714 118.187C86.714 118.219 85.6107 118.444 83.7936 118.734Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3659 129.197L74.5458 129.422C74.5458 129.422 73.7671 129.583 72.6638 129.808C72.6314 129.808 72.5989 129.841 72.534 129.841C72.0149 130.42 71.1388 130.163 70.6845 130.259C70.6196 130.259 70.5547 130.259 70.5222 130.259C70.36 130.259 70.1978 130.291 70.068 130.324C70.0355 130.324 69.9706 130.356 69.9382 130.356C68.0562 130.742 66.304 131.096 66.304 131.096C66.304 131.096 66.9854 130.613 68.3807 129.808C68.4131 129.776 68.4455 129.776 68.478 129.744C68.6078 128.971 70.0355 129.841 70.1329 128.81C70.1653 128.778 70.1978 128.746 70.2627 128.746C70.6196 128.553 70.9765 128.36 71.3659 128.167C71.3984 128.134 71.4308 128.134 71.4633 128.102C71.9824 127.587 72.5016 127.297 73.0208 127.265C73.0532 127.265 73.1181 127.265 73.1506 127.265C73.7346 126.975 74.3187 127.265 74.6107 126.557C74.6432 126.525 74.6756 126.525 74.7405 126.492C79.186 124.4 85.4809 121.824 93.9175 119.12L94.0149 119.732C94.0149 119.732 93.3984 120.279 94.0149 121.213C94.0798 121.309 94.1447 121.438 94.1771 121.567C90.4131 122.307 83.1122 123.981 75.7789 127.104C75.7464 127.104 75.714 127.136 75.6815 127.136C75.1948 127.812 74.6432 127.812 73.9293 127.909C73.8969 127.909 73.8644 127.941 73.832 127.941C73.7995 127.973 73.7671 127.973 73.7346 127.973C73.2155 127.78 72.6638 128.07 72.5016 128.553C72.4691 128.585 72.4367 128.585 72.4043 128.617C71.9824 128.875 71.6579 129.036 71.3659 129.197Z",
    fill: "#2F456C"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.6433 123.305C66.2716 124.046 55.8557 122.082 55.8557 122.082C56.31 122.05 56.7318 122.114 56.7318 122.114C56.8941 122.017 57.0563 121.921 57.2185 121.824C61.2746 123.112 74.6433 123.305 74.6433 123.305Z",
    fill: "black"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.6167 123.177C53.7789 123.144 53.9736 123.144 54.1683 123.209C54.655 123.338 54.8497 123.273 54.9146 123.048C55.3365 123.177 56.1477 123.338 57.543 123.466C61.0149 123.756 61.4043 123.917 62.832 124.207C64.2598 124.497 65.5253 124.432 67.2126 124.658C68.835 124.883 55.4663 124.271 53.6167 123.177Z",
    fill: "black"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.6638 127.233C71.0739 126.686 67.7317 126.299 64.3895 126.235C61.599 126.171 54.4603 125.141 52.124 124.819C52.5134 124.593 52.8379 124.368 52.8379 124.078C53.5842 124.143 54.8172 124.303 55.7907 124.69C57.0237 125.205 61.2096 125.817 63.1889 125.881C65.1683 125.945 72.9559 125.72 75.714 127.137C78.4721 128.553 87.2981 129.294 87.655 129.615C87.9795 130.002 74.2538 127.813 72.6638 127.233Z",
    fill: "black"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.8999 129.422C57.8999 129.422 54.4604 128.585 54.2332 128.585C54.0061 128.585 51.7347 128.263 51.7347 128.263L49.0415 127.941C49.1388 127.844 49.2362 127.748 49.3335 127.651C49.5607 127.426 49.8852 126.621 50.2096 126.074C51.0858 126.75 52.1565 127.555 52.4486 127.716C52.9678 128.005 56.8616 128.488 56.8616 128.488L57.8999 129.422Z",
    fill: "black"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.8469 125.849L92.6198 126.235V127.877L88.2068 131.225L87.3307 133.479L75.5519 133.189C75.7466 132.867 75.8764 132.577 75.779 132.448C75.5195 132.126 68.608 128.81 68.608 128.81L67.6021 128.231C67.7643 128.231 73.0858 129.905 73.897 130.388C74.6758 130.871 77.6935 132.159 77.6935 132.159L86.779 132.931C86.779 132.931 87.9472 130.613 88.1094 130.581C88.2717 130.517 91.841 128.231 91.841 128.231C91.841 128.231 91.9059 126.46 92.0681 126.46C92.1655 126.493 92.7495 126.01 92.8469 125.849Z",
    fill: "black"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.773 133.157L47.2568 132.513C46.9972 132.191 46.8674 131.837 46.8674 131.45C46.8674 131.322 46.8674 131.193 46.8999 131.096C47.3217 131.547 47.9058 132.062 48.1654 132.062C48.6521 132.062 51.0857 132.352 51.248 132.352C51.4102 132.352 55.3365 132.03 55.3365 132.03C55.3365 132.03 56.0179 131.096 56.6993 131.386C57.3807 131.676 61.1772 132.352 61.1772 132.352C61.1772 132.352 62.8645 132.287 63.2863 132.352C63.6757 132.416 65.1683 132.223 65.7199 132.352C66.2716 132.448 66.6934 132.384 68.0562 132.352C69.4191 132.352 70.6521 132.577 71.2686 132.384C71.658 132.287 73.5724 132.802 74.773 133.157Z",
    fill: "black"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2068 132.835C66.2068 132.835 68.5431 131.193 68.8351 131.322C69.1271 131.45 69.9708 131.74 70.7171 131.966C71.4634 132.223 72.4693 132.803 72.4693 132.803C72.4693 132.803 73.3454 132.738 73.7348 132.803C74.1242 132.867 76.3307 133.318 76.3307 133.318H64.7791L66.2068 132.835Z",
    fill: "#2F456C"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6786 133.382L61.7288 130.324L60.95 128.811L53.2598 133.382H58.6786Z",
    fill: "#2F456C"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.2068 132.835C66.2068 132.835 68.5431 131.193 68.8351 131.322C69.1271 131.45 69.9708 131.74 70.7171 131.966C71.4634 132.223 72.4693 132.803 72.4693 132.803C72.4693 132.803 73.3454 132.738 73.7348 132.803C74.1242 132.867 76.3307 133.318 76.3307 133.318H64.7791L66.2068 132.835Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.6786 133.382L61.7288 130.324L60.95 128.811L53.2598 133.382H58.6786Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1388 133.382H65.8822L64.5518 131.805L60.6255 131.322H58.4515L56.7966 133.382H60.1388Z",
    fill: "#2F456C"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9678 132.094L42.6492 130.034C42.6492 130.034 43.6551 129.1 44.012 129.326C44.3365 129.519 47.6462 131.418 47.6462 131.418L53.9737 132.513L55.3365 133.35H42.7465L41.9678 132.094Z",
    fill: "#2F456C"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.1388 133.382H65.8822L64.5518 131.805L60.6255 131.322H58.4515L56.7966 133.382H60.1388Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.9678 132.094L42.6492 130.034C42.6492 130.034 43.6551 129.1 44.012 129.326C44.3365 129.519 47.6462 131.418 47.6462 131.418L53.9737 132.513L55.3365 133.35H42.7465L41.9678 132.094Z",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.6579 115.128C93.6579 115.128 90.8674 115.064 90.2508 115.032C89.6343 114.999 92.2302 114.323 92.2302 114.323L90.2508 110.203L88.888 110.138L85.0916 110.782L86.8113 109.72L88.1741 108.239L87.7848 109.72H90.1859L92.652 113.84C92.6196 113.84 92.9765 114.581 93.6579 115.128Z",
    fill: "black"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.95 124.013L93.5282 124.689C93.5282 124.689 93.5282 124.689 93.4957 124.722C93.4957 124.754 93.4633 124.754 93.4633 124.786L93.4308 124.818L93.3984 124.85C93.3659 124.883 93.3659 124.915 93.3335 124.947C93.301 125.011 93.2362 125.076 93.2037 125.172C93.1713 125.204 93.1713 125.269 93.1388 125.301L93.0415 125.462C92.9441 125.623 92.8792 125.752 92.8468 125.816L92.6196 126.17L87.655 125.494L92.8468 125.076L93.658 123.402V121.76L93.2037 120.955L93.5606 119.506L93.2037 118.379L92.2303 118.669L93.5606 116.898V116.351L93.658 115.031C94.3394 115.579 93.658 117.542 93.658 117.542L93.8851 119.088L93.9825 119.699C93.9825 119.699 93.3659 120.247 93.9825 121.18C94.0149 121.245 94.0474 121.277 94.0798 121.341C94.0798 121.341 94.0798 121.341 94.0798 121.373C94.1123 121.438 94.1123 121.502 94.1447 121.534C94.1772 121.599 94.1772 121.631 94.1772 121.695C94.3718 122.726 93.95 124.013 93.95 124.013Z",
    fill: "black"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8469 133.607H99.2392L97.8115 130.098L95.0209 128.617L92.0681 130.098L90.9324 131.321L89.3749 132.352L88.8882 133.382L92.8469 133.607Z",
    fill: "#2F456C"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M102.095 133.189C102.095 133.189 99.5962 127.362 99.9207 127.265C100.213 127.201 100.959 126.138 100.991 125.848C101.056 125.559 100.667 124.142 100.667 124.142C100.667 124.142 101.738 121.792 102.127 121.502C102.517 121.213 103.198 120.858 103.198 120.858C103.198 120.858 108.163 127.78 109.006 133.382L101.478 133.639L102.095 133.189Z",
    fill: "#2F456C"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M99.2392 133.607H92.8469L88.8882 133.382L89.3749 132.352L90.9324 131.321L92.0681 130.098L95.0209 128.617L97.8115 130.098L99.2392 133.607Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M101.446 133.607L102.095 133.189C102.095 133.189 99.5962 127.362 99.9207 127.265C100.213 127.201 100.959 126.138 100.991 125.848C101.056 125.559 100.667 124.142 100.667 124.142C100.667 124.142 101.738 121.792 102.127 121.502C102.484 121.213 103.133 120.891 103.166 120.858C103.166 120.858 108.163 127.78 108.974 133.382L101.446 133.607Z",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M97.8115 130.098L99.2392 133.607H92.8469L88.8557 133.35C88.8557 133.35 89.8941 132.867 90.1536 132.931C90.4132 132.996 94.7289 132.963 94.8911 132.931C95.0534 132.899 97.2274 132.319 97.2274 132.319L97.13 130.645L96.3513 130.098H95.4427L95.0534 128.617L97.8115 130.098Z",
    fill: "black"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M103.944 129.647C104.074 129.873 104.171 130.034 104.171 130.098C104.204 130.259 104.106 130.034 103.944 129.647Z",
    fill: "black"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.446 133.607L102.095 133.189C102.095 133.189 99.5962 127.362 99.9207 127.265C100.213 127.201 100.959 126.138 100.991 125.848C101.056 125.559 100.667 124.142 100.667 124.142C100.667 124.142 101.738 121.792 102.127 121.502C102.484 121.213 103.133 120.891 103.166 120.858C103.101 120.923 102.257 122.082 102.16 122.243C102.062 122.404 101.089 124.046 101.089 124.046L101.543 125.14C101.543 125.14 102.16 125.72 102.906 127.233C103.328 128.134 103.75 129.1 103.977 129.647C103.36 128.617 101.738 126.203 101.738 126.203C101.738 126.203 101.576 127.168 101.413 127.201C101.251 127.265 101.251 127.394 101.121 127.587C101.024 127.78 101.673 128.939 101.738 129.39C101.803 129.84 102.679 132.931 102.679 132.931L109.039 133.35L101.446 133.607Z",
    fill: "black"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3567 83.16C97.5838 83.0312 97.8759 82.9024 98.1355 82.7414C98.395 82.6127 98.6546 82.4517 98.9142 82.2907C99.4334 81.9688 99.9526 81.6469 100.439 81.3249C101.445 80.6489 102.386 79.8762 103.23 79.0392C103.327 78.9426 103.425 78.8138 103.522 78.7172L103.684 78.5563L103.749 78.4919L103.781 78.4597C103.749 78.5241 103.781 78.5241 103.781 78.4275C103.814 78.3631 103.814 78.2665 103.814 78.1377C103.846 77.6548 103.749 77.0753 103.619 76.4637C103.392 75.2725 103.035 74.0813 102.678 72.8902L103.717 72.4395C104.366 73.5662 104.885 74.7574 105.339 76.013C105.534 76.6568 105.728 77.3007 105.793 78.0734C105.793 78.2665 105.793 78.4919 105.761 78.7172C105.728 78.9748 105.663 79.2645 105.436 79.5865L105.404 79.6508L105.371 79.683L105.339 79.7474L105.242 79.844L105.079 80.0372C104.982 80.1659 104.852 80.2947 104.755 80.4235C103.846 81.4215 102.84 82.3229 101.737 83.0956C101.186 83.4819 100.634 83.8682 100.082 84.1902C99.7903 84.3511 99.4983 84.5121 99.2063 84.6731C98.9142 84.834 98.6222 84.995 98.2977 85.1238L97.3567 83.16Z",
    fill: "#FFB573"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9879 144.908C95.1826 144.908 95.4097 144.876 95.572 144.843C95.6044 144.843 95.6044 144.811 95.6044 144.811C95.6044 144.779 95.6044 144.779 95.572 144.747C95.5071 144.682 94.8256 144.264 94.5661 144.393C94.5336 144.425 94.4687 144.457 94.4687 144.554C94.4363 144.682 94.4687 144.779 94.5661 144.843C94.6634 144.876 94.8256 144.908 94.9879 144.908ZM95.4422 144.747C95.0528 144.811 94.7607 144.811 94.6634 144.715C94.631 144.682 94.5985 144.618 94.5985 144.521C94.5985 144.489 94.631 144.457 94.631 144.457C94.7607 144.393 95.1501 144.586 95.4422 144.747Z",
    fill: "#2F456C"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M95.572 144.811C95.572 144.811 95.6044 144.811 95.572 144.811C95.6044 144.779 95.6369 144.779 95.6369 144.747C95.6369 144.714 95.6369 144.071 95.3773 143.877C95.3124 143.813 95.2475 143.813 95.1502 143.813C95.0204 143.813 94.9879 143.91 94.9879 143.974C94.923 144.199 95.3448 144.682 95.572 144.811ZM95.1826 143.91C95.215 143.91 95.2799 143.91 95.3124 143.942C95.4422 144.071 95.5071 144.425 95.5071 144.65C95.3124 144.489 95.0528 144.135 95.0852 143.974C95.0852 143.974 95.1177 143.942 95.1826 143.91Z",
    fill: "#2F456C"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3774 76.5923C95.1178 77.9122 94.5662 80.5521 95.5072 81.4213C95.5072 81.4213 95.1503 82.7413 92.7166 82.7413C90.0234 82.7413 91.4187 81.4213 91.4187 81.4213C92.8789 81.0672 92.8464 80.0048 92.5868 78.9746L95.3774 76.5923Z",
    fill: "#FFB573"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8994 81.9365C90.4776 82.0009 90.8345 80.9063 90.9968 80.8097C91.3861 80.5522 96.513 80.198 96.4805 80.8097C96.4481 81.0673 96.3183 81.5824 96.1236 81.7755C95.8965 81.9365 94.5661 81.3892 90.8994 81.9365Z",
    fill: "#263238"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7431 81.5824C91.4186 81.6789 91.4511 80.6165 91.5484 80.4556C91.808 80.1658 95.9614 79.1034 96.0912 79.6829C96.1236 79.9405 96.1561 80.4556 96.0263 80.6487C95.8641 80.8741 94.631 80.5522 91.7431 81.5824Z",
    fill: "#263238"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1857 74.2423C90.1532 74.2423 90.1208 74.2423 90.0883 74.2101C89.7963 73.856 89.4069 73.8882 89.4069 73.8882C89.342 73.8882 89.3095 73.856 89.2771 73.7916C89.2771 73.7272 89.3095 73.695 89.3744 73.6628C89.4069 73.6628 89.8612 73.5985 90.2506 74.0492C90.283 74.0814 90.283 74.1458 90.2506 74.2101C90.2181 74.2423 90.2181 74.2423 90.1857 74.2423Z",
    fill: "#263238"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6664 75.5303C89.6664 75.5303 89.4393 76.3351 89.1472 76.7214C89.4068 76.9146 89.7962 76.7858 89.7962 76.7858L89.6664 75.5303Z",
    fill: "#FF5652"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7963 75.2082C89.8287 75.3692 89.7314 75.5301 89.6016 75.5623C89.4718 75.5623 89.3745 75.4336 89.3745 75.2726C89.342 75.1116 89.4393 74.9507 89.5691 74.9185C89.6665 74.9185 89.7963 75.0472 89.7963 75.2082Z",
    fill: "#263238"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6015 74.9184L89.1472 74.8218C89.1797 74.854 89.4393 75.1437 89.6015 74.9184Z",
    fill: "#263238"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1679 144.779H95.929L96.1236 139.66H98.3301L98.1679 144.779Z",
    fill: "#FFB573"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7669 144.521H98.2654C98.3627 144.521 98.4276 144.585 98.4276 144.682L98.7197 146.646C98.7521 146.839 98.5574 147.032 98.3627 147.032C97.4866 147.032 97.0648 146.968 95.994 146.968C95.3126 146.968 94.3391 147.032 93.3981 147.032C92.4896 147.032 92.4247 146.131 92.8141 146.034C94.5663 145.648 94.8259 145.165 95.4099 144.65C95.5073 144.553 95.6371 144.521 95.7669 144.521Z",
    fill: "#263238"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3302 139.66H96.1237L96.0264 142.3H98.2329L98.3302 139.66Z",
    fill: "black"
  }))), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M89.342 84.4799C87.9792 83.9326 86.6488 83.3531 85.3508 82.7093C84.0529 82.0332 82.755 81.3571 81.5544 80.3913C81.2623 80.166 80.9379 79.8762 80.6458 79.5865C80.5809 79.5221 80.4836 79.4255 80.4187 79.3289C80.3538 79.2323 80.2889 79.1679 80.1915 79.0392C79.9969 78.7816 79.8671 78.4275 79.8346 78.1056C79.8022 77.7514 79.8671 77.4295 79.9644 77.1397C80.0618 76.8822 80.1915 76.6568 80.3213 76.4637C80.6134 76.0774 80.9054 75.7876 81.2299 75.5301C81.8464 75.015 82.4954 74.6608 83.1768 74.3067C83.5013 74.1457 83.8258 73.9848 84.1827 73.8238C84.5072 73.6628 84.8641 73.534 85.221 73.4053L85.6753 74.4033C84.5072 75.1115 83.339 75.9164 82.4305 76.8178C82.2033 77.0432 82.0411 77.2685 81.9113 77.4617C81.7815 77.6548 81.7815 77.8158 81.814 77.8158C81.814 77.8158 81.814 77.8158 81.8464 77.848L81.9438 77.9446C81.9762 77.9768 82.0411 78.0412 82.0736 78.0734C82.2682 78.2665 82.5278 78.4597 82.7874 78.6529C83.3066 79.0392 83.8907 79.3611 84.4747 79.683C85.0588 80.005 85.6753 80.3269 86.3243 80.6167C87.5573 81.1962 88.8553 81.7756 90.1208 82.2907L89.342 84.4799Z",
    fill: "#FFB573"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3244 73.7271L86.6813 72.9545L85.0264 72.375C85.0264 72.375 84.5072 73.9203 85.1238 74.6286C85.6429 74.5642 86.0972 74.21 86.3244 73.7271Z",
    fill: "#FFB573"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6812 71.2481L85.3509 70.8618L85.0264 72.3749L86.6812 72.9544V71.2481Z",
    fill: "#FFB573"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M103.879 73.0191L104.074 71.1841L102.354 71.5704C102.354 71.5704 102.321 73.3089 103.23 73.5664L103.879 73.0191Z",
    fill: "#FFB573"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M103.262 69.896L102.127 70.4111L102.354 71.5701L104.074 71.1837L103.262 69.896Z",
    fill: "#FFB573"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7342 74.017C95.7991 76.2062 95.8965 77.1076 94.8906 78.331C93.3979 80.166 90.6723 79.7797 89.9584 77.6871C89.3094 75.7877 89.277 72.5361 91.3212 71.4737C93.333 70.4114 95.6369 71.8279 95.7342 74.017Z",
    fill: "#FFB573"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7608 78.3311C96.9348 77.3975 98.3301 75.4658 97.746 72.4074C97.1619 69.4778 95.1826 69.1881 94.3714 69.7997C93.5602 70.4114 91.5159 69.51 90.2829 70.5402C88.1413 72.3109 90.1531 74.2425 91.2239 75.3693C91.8404 76.657 92.6516 79.2647 94.7608 78.3311Z",
    fill: "#263238"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8846 71.8924C94.5985 72.9226 95.9938 73.2445 96.9997 72.5363C98.0056 71.8602 98.2003 70.4437 97.4864 69.4135C96.7725 68.3833 95.3773 68.0613 94.3714 68.7696C93.3655 69.4457 93.1383 70.8622 93.8846 71.8924Z",
    fill: "#2F456C"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4363 70.0249C94.1118 68.2543 95.7991 66.9021 98.0381 67.5782C100.277 68.2221 99.1089 70.2181 98.6221 71.7956C98.1679 73.3731 99.3684 74.8862 99.8876 73.6628C100.407 72.4716 99.5307 72.0853 99.5307 72.0853C99.5307 72.0853 101.899 72.697 99.6929 75.3691C97.4864 78.0412 95.4746 75.0793 96.0263 73.3409C96.4805 71.9244 94.7283 71.6668 94.4363 70.0249Z",
    fill: "#263238"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1973 70.6689C91.1589 70.1538 89.4392 69.7031 88.4657 71.3449C88.0114 72.1176 88.1737 73.18 88.1737 73.18L91.1914 73.3732L92.1973 70.6689Z",
    fill: "#263238"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8168 72.6971C87.7844 72.6971 87.752 72.6649 87.752 72.6327C87.752 72.6005 87.8168 71.5381 88.4658 70.8621C90.0233 69.2524 91.8404 70.6045 92.3596 71.023C92.3921 71.0552 92.3921 71.0874 92.3596 71.1196C92.3272 71.1518 92.2947 71.1518 92.2623 71.1196C91.7755 70.7011 90.0233 69.4133 88.5632 70.9265C87.9466 71.5381 87.8817 72.6005 87.8817 72.6005C87.8817 72.6649 87.8493 72.6971 87.8168 72.6971Z",
    fill: "#263238"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M91.581 75.2725C91.581 75.691 91.3863 76.1095 91.1267 76.3993C90.7698 76.8178 90.348 76.6246 90.2506 76.1417C90.1533 75.7232 90.2506 74.9827 90.7049 74.7252C91.1592 74.4998 91.581 74.7896 91.581 75.2725Z",
    fill: "#FFB573"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0942 95.2646C91.0942 95.2646 91.224 110.524 92.5544 119.024C93.6252 125.881 95.637 141.785 95.637 141.785H98.6547C98.6547 141.785 98.9467 126.46 98.3951 119.635C96.9998 102.444 100.569 99.2244 97.7137 95.2324H91.0942V95.2646Z",
    fill: "#263238"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.0942 95.2646C91.0942 95.2646 91.224 110.524 92.5544 119.024C93.6252 125.881 95.637 141.785 95.637 141.785H98.6547C98.6547 141.785 98.9467 126.46 98.3951 119.635C96.9998 102.444 100.569 99.2244 97.7137 95.2324H91.0942V95.2646Z",
    fill: "white"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.6841 102.187C93.7549 106.79 92.9112 114.066 92.3271 117.253C91.7106 112.392 91.4186 106.114 91.2563 101.511C91.808 100.609 92.3271 100.545 92.6841 102.187Z",
    fill: "black"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2475 141.849H99.0764L99.3036 140.497L95.2151 140.368L95.2475 141.849Z",
    fill: "#2F456C"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3509 82.3553C96.7078 81.647 98.6547 81.1963 99.7255 81.1963L100.537 84.7054C100.537 84.7054 98.4276 87.8282 97.519 87.5063C96.4482 87.1199 95.5721 83.9006 96.3509 82.3553Z",
    fill: "#2F456C"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.3509 82.3553C96.7078 81.647 98.6547 81.1963 99.7255 81.1963L100.537 84.7054C100.537 84.7054 98.4276 87.8282 97.519 87.5063C96.4482 87.1199 95.5721 83.9006 96.3509 82.3553Z",
    fill: "black"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0794 140.98C94.0794 140.98 94.0794 140.948 94.0794 140.915C94.0794 140.883 94.0469 140.883 94.0145 140.883C93.9171 140.915 92.9112 141.044 92.7814 141.334C92.749 141.398 92.749 141.431 92.7814 141.495C92.8463 141.592 92.9112 141.624 93.0086 141.656C93.3655 141.72 93.8522 141.27 94.0794 140.98ZM92.9112 141.398C93.0086 141.237 93.4953 141.109 93.8847 141.044C93.5277 141.398 93.2357 141.592 93.041 141.559C92.9761 141.559 92.9437 141.527 92.8788 141.463C92.9112 141.431 92.9112 141.431 92.9112 141.398Z",
    fill: "#2F456C"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0794 140.98C94.0794 140.948 94.0794 140.948 94.0794 140.916C94.047 140.883 93.6576 140.433 93.3007 140.433C93.2033 140.433 93.106 140.465 93.0086 140.529C92.9113 140.626 92.9113 140.722 92.9437 140.755C93.0735 140.98 93.7549 141.044 94.047 141.012C94.0794 141.012 94.0794 141.012 94.0794 140.98ZM93.0411 140.658L93.0735 140.626C93.1384 140.561 93.2033 140.561 93.3007 140.561C93.5278 140.561 93.8198 140.819 93.9172 140.948C93.5927 140.98 93.106 140.883 93.0411 140.755C93.0411 140.722 93.0411 140.69 93.0411 140.658Z",
    fill: "#2F456C"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4158 140.046L94.3715 140.948L93.463 139.08L92.2948 136.634L92.165 136.344L94.1768 135.475L94.3391 135.797L95.4748 138.147L96.4158 140.046Z",
    fill: "#FFB573"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.4746 138.147L93.4628 139.081L92.2947 136.634L94.3389 135.797L95.4746 138.147Z",
    fill: "black"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7255 95.2646C88.7255 95.2646 82.2359 111.233 84.0205 118.766C85.6105 125.559 92.6193 138.436 92.6193 138.436L95.345 137.084C95.345 137.084 90.9969 121.535 90.5426 118.154C89.6341 111.587 95.5072 102.315 95.5072 95.2646H88.7255Z",
    fill: "#263238"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.7255 95.2646C88.7255 95.2646 82.2359 111.233 84.0205 118.766C85.6105 125.559 92.6193 138.436 92.6193 138.436L95.345 137.084C95.345 137.084 90.9969 121.535 90.5426 118.154C89.6341 111.587 95.5072 102.315 95.5072 95.2646H88.7255Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0145 140.658L96.0263 139.209C96.0912 139.145 96.1885 139.177 96.2534 139.242L97.6487 140.658C97.7785 140.819 97.7785 141.077 97.5838 141.173C96.87 141.656 96.513 141.881 95.6045 142.525C95.0529 142.912 93.9821 143.781 93.2357 144.328C92.4894 144.876 91.9054 144.167 92.1649 143.878C93.3655 142.558 93.5927 141.753 93.7874 141.012C93.8198 140.851 93.9172 140.755 94.0145 140.658Z",
    fill: "#263238"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4246 138.984L95.929 137.406L95.4747 135.99L91.7432 137.696L92.4246 138.984Z",
    fill: "#2F456C"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4453 82.1939C90.1533 81.4535 87.6223 80.6164 86.3568 80.3589L85.8052 84.5119C85.8052 84.5119 87.8819 87.4737 88.7904 87.2162C89.8612 86.8942 91.0618 83.8036 90.4453 82.1939Z",
    fill: "#2F456C"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.4453 82.1939C90.1533 81.4535 87.6223 80.6164 86.3568 80.3589L85.8052 84.5119C85.8052 84.5119 87.8819 87.4737 88.7904 87.2162C89.8612 86.8942 91.0618 83.8036 90.4453 82.1939Z",
    fill: "black"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6547 81.9688C87.6547 81.9688 86.5839 82.3229 88.7255 95.2326C92.2948 95.2326 95.9939 95.2326 97.7137 95.2326C97.5514 91.5947 97.5514 89.3411 99.3036 81.9044C99.3036 81.9044 97.4216 81.4859 95.4747 81.3893C93.9496 81.3249 92.7166 81.2605 91.3862 81.3893C89.6665 81.5825 87.6547 81.9688 87.6547 81.9688Z",
    fill: "#2F456C"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.6547 81.9688C87.6547 81.9688 86.5839 82.3229 88.7255 95.2326C92.2948 95.2326 95.9939 95.2326 97.7137 95.2326C97.5514 91.5947 97.5514 89.3411 99.3036 81.9044C99.3036 81.9044 97.4216 81.4859 95.4747 81.3893C93.9496 81.3249 92.7166 81.2605 91.3862 81.3893C89.6665 81.5825 87.6547 81.9688 87.6547 81.9688Z",
    fill: "black"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8758 94.7177L98.2977 95.5226C98.3301 95.5869 98.2652 95.6513 98.1354 95.6513H88.6929C88.5956 95.6513 88.5307 95.6191 88.5307 95.5547L88.4333 94.7499C88.4333 94.6855 88.4982 94.6533 88.5956 94.6533H97.7136C97.7785 94.6533 97.8434 94.6855 97.8758 94.7177Z",
    fill: "#2F456C"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.8758 94.7177L98.2977 95.5226C98.3301 95.5869 98.2652 95.6513 98.1354 95.6513H88.6929C88.5956 95.6513 88.5307 95.6191 88.5307 95.5547L88.4333 94.7499C88.4333 94.6855 88.4982 94.6533 88.5956 94.6533H97.7136C97.7785 94.6533 97.8434 94.6855 97.8758 94.7177Z",
    fill: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6429 95.7478H96.9025C96.9349 95.7478 96.9998 95.7157 96.9998 95.6835L96.87 94.6533C96.87 94.6211 96.8376 94.5889 96.7727 94.5889H96.5131C96.4807 94.5889 96.4158 94.6211 96.4158 94.6533L96.5456 95.6835C96.5456 95.7157 96.578 95.7478 96.6429 95.7478Z",
    fill: "#263238"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7049 95.7478H90.9645C90.997 95.7478 91.0619 95.7157 91.0619 95.6835L90.9321 94.6533C90.9321 94.6211 90.8996 94.5889 90.8347 94.5889H90.5751C90.5427 94.5889 90.4778 94.6211 90.4778 94.6533L90.6076 95.6835C90.64 95.7157 90.6725 95.7478 90.7049 95.7478Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearmiss);
export default __webpack_public_path__ + "static/media/nearmiss.854ca71497a9adcf9cf6898303fc64d3.svg";
export { ForwardRef as ReactComponent };